import TableContents from '../types/TableContents';

export const ADOBE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/adobe-air/getting-started/integration' ],
    rightMenuNavs: [
        {
            displayName: 'Download the Latest Extension',
            hashName: '#download-the-latest-extension',
            level: 1,
        },
        {
            displayName: 'Import the Extension',
            hashName: '#import-the-extension',
            level: 1,
        },
        {
            displayName: 'Android Manifest',
            hashName: '#android-manifest',
            level: 1,
        },
        {
            displayName: 'Permissions',
            hashName: '#permissions',
            level: 2,
        },
        {
            displayName: 'Activities, Providers, and Services',
            hashName: '#activities,-providers,-and-services',
            level: 2,
        },
        {
            displayName: 'Initialize the SDK',
            hashName: '#initialize-the-sdk',
            level: 1,
        },
        {
            displayName: 'iOS 14 Support',
            hashName: '#ios-14-support',
            level: 1,
        },
        {
            displayName: 'SKAdNetwork',
            hashName: '#skadnetwork',
            level: 2,
        },
        {
            displayName: 'Consent and Data APIs',
            hashName: '#consent-and-data-apis',
            level: 2,
        },
        {
            displayName: 'iOS 15 Global SKAdNetwork Reporting',
            hashName: '#ios-15-global-skadnetwork-reporting',
            level: 1,
        },
    ]
}

export const ORTB_INTRODUCTION_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dsps/ortb-spec/introduction' ],
    rightMenuNavs: [
        {
            displayName: 'Protocol Details',
            hashName: '#protocol-details',
            level: 1,
        },
        {
            displayName: 'Bid Regions',
            hashName: '#bid-regions',
            level: 1,
        },
        {
            displayName: 'Endpoints',
            hashName: '#endpoints',
            level: 1,
        },
        {
            displayName: 'Supported Ad Formats',
            hashName: '#supported-ad-formats',
            level: 1,
        },
        {
            displayName: 'Supported Ad Sizes',
            hashName: '#supported-ad-sizes',
            level: 1,
        },
        {
            displayName: 'Exchange Currency',
            hashName: '#exchange-currency',
            level: 1,
        },
        {
            displayName: 'Auction Type',
            hashName: '#auction-type',
            level: 1,
        },
        {
            displayName: 'Blocked Creative Types',
            hashName: '#blocked-creative-types',
            level: 1,
        },
        {
            displayName: 'Blocked Categories',
            hashName: '#blocked-categories',
            level: 1,
        },
        {
            displayName: 'Blocked Ad Types',
            hashName: '#blocked-ad-types',
            level: 1,
        },
    ]
}
export const ORTB_BID_REQUEST_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dsps/ortb-spec/bid-request' ],
    rightMenuNavs: [
        {
            displayName: 'Request Objects',
            hashName: '#request-objects',
            level: 1,
        },
        {
            displayName: 'Seats',
            hashName: '#seats',
            level: 1,
        },
        {
            displayName: 'Bid Request Object',
            hashName: '#bid-request-object',
            level: 1,
        },
        {
            displayName: 'App Object',
            hashName: '#app-object',
            level: 1,
        },
        {
            displayName: 'Device Object',
            hashName: '#device-object',
            level: 1,
        },
        {
            displayName: 'Geo Object',
            hashName: '#geo-object',
            level: 1,
        },
        {
            displayName: 'Impression Object',
            hashName: '#impression-object',
            level: 1,
        },
        {
            displayName: 'Metric Object',
            hashName: '#metric-object',
            level: 1,
        },
        {
            displayName: 'Video Object',
            hashName: '#video-object',
            level: 1,
        },
        {
            displayName: 'Banner Object',
            hashName: '#banner-object',
            level: 1,
        },
        {
            displayName: 'Native Object',
            hashName: '#native-object',
            level: 1,
        },
        {
            displayName: 'Example Bid Request',
            hashName: '#example-bid-request',
            level: 1,
        },
        {
            displayName: 'Example Native Bid Request',
            hashName: '#example-native-bid-request',
            level: 1,
        },
        {
            displayName: 'Example CTV Bid Request',
            hashName: '#example-ctv-bid-request',
            level: 1,
        },
    ]
}
export const ORTB_BID_RESPONSE_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dsps/ortb-spec/bid-response' ],
    rightMenuNavs: [
        {
            displayName: 'Size',
            hashName: '#size',
            level: 1,
        },
        {
            displayName: 'No Bids',
            hashName: '#no-bids',
            level: 1,
        },
        {
            displayName: 'Win/Loss/Billing Notifications',
            hashName: '#win/loss/billing-notifications',
            level: 1,
        },
        {
            displayName: 'Ad Markup Standard',
            hashName: '#ad-markup-standard',
            level: 1,
        },
        {
            displayName: 'Bid Response Component',
            hashName: '#bid-response-components',
            level: 1,
        },
        {
            displayName: 'Bid Response Object',
            hashName: '#bid-response-object',
            level: 1,
        },
        {
            displayName: 'Seatbid Object',
            hashName: '#seatbid-object',
            level: 1,
        },
        {
            displayName: 'Bid Object',
            hashName: '#bid-object',
            level: 1,
        },
        {
            displayName: 'Tracking Fields',
            hashName: '#tracking-fields',
            level: 1,
        },
        {
            displayName: 'Example Bid Response',
            hashName: '#example-bid-response',
            level: 1,
        },
        {
            displayName: 'Example Native Ad Response',
            hashName: '#example-native-ad-response',
            level: 1,
        },
    ]
}
export const ORTB_CREATIVE_TYPES_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dsps/ortb-spec/creative-types' ],
    rightMenuNavs: [
        {
            displayName: 'VAST Support',
            hashName: '#vast-support',
            level: 1,
        },
        {
            displayName: 'MRAID Support',
            hashName: '#mraid-support',
            level: 1,
        },
        {
            displayName: 'HTML Support',
            hashName: '#html-support',
            level: 1,
        },
        {
            displayName: 'Native Support',
            hashName: '#native-support',
            level: 1,
        },
        {
            displayName: 'CTV Support',
            hashName: '#ctv-support',
            level: 1,
        },
        {
            displayName: 'Ad Caching',
            hashName: '#ad-caching',
            level: 1,
        },
    ]
}

export const SDK_BIDDERS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/auction-dynamics' ],
    rightMenuNavs: [
        {
            displayName: 'Auction Dynamics',
            hashName: '#auction-dynamics',
            level: 1,
        },
        {
            displayName: 'MAX Ad Serving Flow',
            hashName: '#max-ad-serving-flow',
            level: 1,
        },
    ]
}

export const DV360_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dv360' ],
    rightMenuNavs: [
        {
            displayName: 'Activate ALX in Your Google DV360 Account',
            hashName: '#activate-alx-in-your-google-dv360-account',
            level: 1,
        },
        {
            displayName: 'How ALX and DV360 Work Together',
            hashName: '#how-alx-and-dv360-work-together',
            level: 1,
        },
        {
            displayName: 'Establish Deals and Inventory Packages',
            hashName: '#establish-deals-and-inventory-packages',
            level: 1,
        },
    ]
}

export const CUSTOM_ADAPTER_ANDROID_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/custom-adapter-android' ],
    rightMenuNavs: [
        {
            displayName: 'Getting Started',
            hashName: '#getting-started',
            level: 1,
        },
        {
            displayName: 'Banner Ads',
            hashName: '#banner-ads',
            level: 1,
        },
        {
            displayName: 'Interstitials',
            hashName: '#interstitials',
            level: 1,
        },
        {
            displayName: 'Rewarded Ads',
            hashName: '#rewarded-ads',
            level: 1,
        },
        {
            displayName: 'Native Ads',
            hashName: '#native-ads',
            level: 1,
        },
        {
            displayName: 'Privacy',
            hashName: '#privacy',
            level: 1,
        },
        {
            displayName: 'Testing',
            hashName: '#testing',
            level: 1,
        },
        {
            displayName: 'Troubleshooting',
            hashName: '#troubleshooting',
            level: 1,
        },
    ]
}

export const CUSTOM_ADAPTER_IOS_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/custom-adapter-ios' ],
    rightMenuNavs: [
        {
            displayName: 'Getting Started',
            hashName: '#getting-started',
            level: 1,
        },
        {
            displayName: 'Banner Ads',
            hashName: '#banner-ads',
            level: 1,
        },
        {
            displayName: 'Interstitials',
            hashName: '#interstitials',
            level: 1,
        },
        {
            displayName: 'Rewarded Ads',
            hashName: '#rewarded-ads',
            level: 1,
        },
        {
            displayName: 'Native Ads',
            hashName: '#native-ads',
            level: 1,
        },
        {
            displayName: 'Privacy',
            hashName: '#privacy',
            level: 1,
        },
        {
            displayName: 'Testing',
            hashName: '#testing',
            level: 1,
        },
        {
            displayName: 'Troubleshooting',
            hashName: '#troubleshooting',
            level: 1,
        },
    ]
}

export const DSPS_TESTING_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dsps/testing' ],
    rightMenuNavs: [
        {
            displayName: 'Testing',
            hashName: '#testing',
            level: 1,
        },
        {
            displayName: 'Test App Functionalities',
            hashName: '#test-app-functionalities',
            level: 2,
        },
        {
            displayName: 'Testing Your Bidder (e2e)',
            hashName: '#testing-your-bidder-(e2e)',
            level: 2,
        },
        {
            displayName: 'Testing Your Bid Response and Creative',
            hashName: '#testing-your-bid-response-and-creative',
            level: 2,
        },
        {
            displayName: 'Launch',
            hashName: '#launch',
            level: 1,
        },
    ]
}

export const DSPS_REPORTING_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dsps/reporting' ],
    rightMenuNavs: [
        {
            displayName: 'Base URL',
            hashName: '#base-url',
            level: 1,
        },
        {
            displayName: 'Example Final URL',
            hashName: '#example-final-url:',
            level: 1,
        },
        {
            displayName: 'Required Parameters',
            hashName: '#required-parameters',
            level: 2,
        },
        {
            displayName: 'Optional Parameters',
            hashName: '#optional-parameters',
            level: 2,
        },
        {
            displayName: 'Basic Reporting Columns',
            hashName: '#basic-reporting-columns',
            level: 1,
        },
        {
            displayName: 'Response Codes',
            hashName: '#response-codes',
            level: 1,
        },
    ]
}

export const DSPS_SKADNETWORK_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dsps/skadnetwork' ],
    rightMenuNavs: [
        {
            displayName: 'How It Works',
            hashName: '#how-it-works',
            level: 1,
        },
        {
            displayName: 'Creative Type Specification',
            hashName: '#creative-type-specification',
            level: 1,
        },
        {
            displayName: 'VAST',
            hashName: '#vast',
            level: 2,
        },
        {
            displayName: 'HTML',
            hashName: '#html',
            level: 2,
        },
        {
            displayName: 'MRAID',
            hashName: '#mraid',
            level: 2,
        },
        {
            displayName: 'Considerations',
            hashName: '#considerations',
            level: 1,
        },
    ]
}

export const DSPS_VIEWABILITY_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dsps/viewability' ],
    rightMenuNavs: [
        {
            displayName: 'Setting Up Viewability Tags',
            hashName: '#setting-up-viewability-tags',
            level: 1,
        },
        {
            displayName: 'Testing Your Viewability Tags',
            hashName: '#testing-your-viewability-tags',
            level: 1,
        },
        {
            displayName: 'Bid Responses',
            hashName: '#bid-responses',
            level: 1,
        },
        {
            displayName: 'Reporting',
            hashName: '#reporting',
            level: 1,
        },
    ]
}

export const DSPS_DELETED_DEVICE_IDS_API: TableContents = {
    pathName: [ '/documentation/mediation/auctions/dsps/gdpr-deleted-device-ids-api' ],
    rightMenuNavs: [
        {
            displayName: 'GDPR Deleted Device IDs API',
            hashName: '#gdpr-deleted-device-ids-api',
            level: 1,
        },
        {
            displayName: 'Authentication',
            hashName: '#authentication',
            level: 2,
        },
        {
            displayName: 'Building the Query',
            hashName: '#building-the-query',
            level: 2,
        },
        {
            displayName: 'Query Parameters',
            hashName: '#query-parameters',
            level: 2,
        },
        {
            displayName: 'Response',
            hashName: '#response',
            level: 1,
        },
        {
            displayName: 'Errors',
            hashName: '#errors',
            level: 2,
        },
        {
            displayName: 'Example Request',
            hashName: '#example-request',
            level: 1,
        },
        {
            displayName: 'Example Response',
            hashName: '#example-response',
            level: 1,
        },
    ]
}

export const MAX_S2S_REWARDED_CALLBACK_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/s2s-rewarded-callback-api' ],
    rightMenuNavs: [
        {
            displayName: 'Introduction',
            hashName: '#introduction',
            level: 1,
        },
        {
            displayName: 'Example',
            hashName: '#example',
            level: 2,
        },
        {
            displayName: 'Available Macros',
            hashName: '#available-macros',
            level: 2,
        },
        {
            displayName: 'Setting an Ad Placement Name',
            hashName: '#setting-an-ad-placement-name',
            level: 1,
        },
        {
            displayName: 'Accessing the Amount and Currency for a Rewarded Ad',
            hashName: '#accessing-the-amount-and-currency-for-a-rewarded-ad',
            level: 1,
        },
        {
            displayName: 'Setting an Internal User ID',
            hashName: '#setting-an-internal-user-id',
            level: 1,
        },
        {
            displayName: 'Custom Data',
            hashName: '#custom-data',
            level: 1,
        }
    ]
}

export const MAX_S2S_IMPRESSION_REVENUE_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/features/s2s-impression-revenue-api' ],
    rightMenuNavs: [
        {
            displayName: 'Direct Integration: MAX to You',
            hashName: '#direct-integration:-max-to-you',
            level: 1,
        },
        {
            displayName: 'MMP Integration: MAX to MMP',
            hashName: '#mmp-integration:-max-to-mmp',
            level: 1,
        },
        {
            displayName: 'Server-to-Server Impression Revenue API',
            hashName: '#server-to-server-impression-revenue-api',
            level: 1,
        },
        {
            displayName: 'Example',
            hashName: '#example',
            level: 2,
        },
        {
            displayName: 'Available Macros',
            hashName: '#available-macros',
            level: 2,
        },
        {
            displayName: 'Setting an Ad Placement Name',
            hashName: '#setting-an-ad-placement-name',
            level: 2,
        },
        {
            displayName: 'Setting an Internal User ID',
            hashName: '#setting-an-internal-user-id',
            level: 2,
        },
        {
            displayName: 'Custom Data',
            hashName: '#custom-data',
            level: 2,
        }
    ]
}

export const ADOBE_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/adobe-air/ad-formats/banners' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Loading a Banner or MREC",
      "hashName":"#loading-a-banner-or-mrec",
      "level":"1"
   },
   {
      "displayName":"Showing and Hiding a Banner or MREC",
      "hashName":"#showing-and-hiding-a-banner-or-mrec",
      "level":"1"
   }
]` )
}

export const ADOBE_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/adobe-air/getting-started/advanced-settings' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Ad Placements",
      "hashName":"#ad-placements",
      "level":"1"
   },
   {
      "displayName":"Banners & MRECs",
      "hashName":"#banners-&-mrecs",
      "level":"2"
   },
   {
      "displayName":"Interstitials",
      "hashName":"#interstitials",
      "level":"2"
   },
   {
      "displayName":"Rewarded Ads",
      "hashName":"#rewarded-ads",
      "level":"2"
   },
   {
      "displayName":"Mute Audio",
      "hashName":"#mute-audio",
      "level":"1"
   },
   {
      "displayName":"Enable Verbose Logging",
      "hashName":"#enable-verbose-logging",
      "level":"1"
   }
]` )
}

export const ANDROID_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/getting-started/integration' ],
    rightMenuNavs: [
        {
            displayName: 'Download the Latest SDK',
            hashName: '#integration',
            level: 1,
        },
        {
            displayName: 'Gradle (Recommended)',
            hashName: '#gradle-(recommended)',
            level: 2,
        },
        {
            displayName: 'Enable Ad Review',
            hashName: '#enable-ad-review',
            level: 1,
        },
        {
            displayName: 'Add the SDK Key',
            hashName: '#add-the-sdk-key',
            level: 1,
        },
        {
            displayName: 'Initialize the SDK',
            hashName: '#initialize-the-sdk',
            level: 1,
        },
        {
            displayName: 'ProGuard Rules',
            hashName: '#proguard-rules',
            level: 1,
        },
        {
           displayName: 'MAX Terms and Privacy Policy Flow',
           hashName: '#max-terms-and-privacy-policy-flow',
           level: 1,
        }
    ]
}

export const ANDROID_APP_OPEN_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/ad-formats/app-open' ],
    rightMenuNavs: [
        {
            displayName: 'App Open Ads',
            hashName: '#app-open-ads',
            level: 1,
        },
        {
            displayName: 'Best Practices',
            hashName: '#best-practices',
            level: 2,
        },
        {
            displayName: 'Retention',
            hashName: '#retention',
            level: 2,
        },
        {
            displayName: 'Using an App Open Ad',
            hashName: '#using-an-app-open-ad',
            level: 1,
        },
        {
            displayName: 'Listen for App Foregrounding Events',
            hashName: '#listen-for-app-foregrounding-events',
            level: 1,
        },
        {
            displayName: 'Cold Starts and Loading Screens',
            hashName: '#cold-starts-and-loading-screens',
            level: 1,
        },
        {
            displayName: 'Examples',
            hashName: '#examples',
            level: 1,
        },
        {
            displayName: 'Supported Adapter Versions',
            hashName: '#supported-adapter-versions',
            level: 1,
        },
    ]
}

export const ADVANCED_FEATURES_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/advanced-features'
    ],
    rightMenuNavs: [
        {
            displayName: 'Automated Network Tests',
            hashName: '#automated-network-tests',
            level: 1,
        },
    ]
}

export const REWARDED_ADS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/ad-formats/rewarded-ads',
        '/documentation/mediation/cordova/ad-formats/rewarded-ads',
        '/documentation/mediation/defold/ad-formats/rewarded-ads',
        '/documentation/mediation/flutter/ad-formats/rewarded-ads',
        '/documentation/mediation/godot/ad-formats/rewarded-ads',
        '/documentation/mediation/react-native/ad-formats/rewarded-ads',
        '/documentation/mediation/unreal/ad-formats/rewarded-ads'
    ],
    rightMenuNavs: [
        {
            displayName: 'Loading a Rewarded Ad',
            hashName: '#loading-a-rewarded-ad',
            level: 1,
        },
        {
            displayName: 'Showing a Rewarded Ad',
            hashName: '#showing-a-rewarded-ad',
            level: 1,
        },
        {
            displayName: 'S2S Rewarded Callbacks',
            hashName: '#s2s-rewarded-callbacks',
            level: 1,
        },
        {
            displayName: 'Setting the Amount and Currency for a Rewarded Ad',
            hashName: '#setting-the-amount-and-currency-for-a-rewarded-ad',
            level: 1,
        },
    ]
}
export const REWARDED_ADS_COMPONENT_TABLE_CONTENTS_2: TableContents = {
    pathName: [
        '/documentation/mediation/android/ad-formats/rewarded-ads',
        '/documentation/mediation/ios/ad-formats/rewarded-ads',
        '/documentation/mediation/unity/ad-formats/rewarded-ads'
    ],
    rightMenuNavs: [
        {
            displayName: 'Loading a Rewarded Ad',
            hashName: '#loading-a-rewarded-ad',
            level: 1,
        },
        {
            displayName: 'Showing a Rewarded Ad',
            hashName: '#showing-a-rewarded-ad',
            level: 1,
        },
        {
            displayName: 'Accessing the Amount and Currency for a Rewarded Ad',
            hashName: '#accessing-the-amount-and-currency-for-a-rewarded-ad',
            level: 1,
        },
        {
            displayName: 'S2S Rewarded Callbacks',
            hashName: '#s2s-rewarded-callbacks',
            level: 1,
        },
        {
            displayName: 'Setting the Amount and Currency for a Rewarded Ad',
            hashName: '#setting-the-amount-and-currency-for-a-rewarded-ad',
            level: 1,
        },
    ]
}

export const ANDROID_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/ad-formats/banners' ],
    rightMenuNavs: [
        {
            displayName: 'Banners & MRECs',
            hashName: '#banners-&-mrecs',
            level: 1,
        },
        {
            displayName: 'Loading and Showing Banners & MRECs Programmatically',
            hashName: '#loading-and-showing-banners-&-mrecs-programmatically',
            level: 2,
        },
        {
            displayName: 'Loading and Showing Banners & MRECs in Layout Editor',
            hashName: '#loading-and-showing-banners-&-mrecs-in-layout-editor',
            level: 2,
        },
        {
            displayName: 'Destroying Banners & MRECs',
            hashName: '#destroying-banners-&-mrecs',
            level: 2,
        },
        {
            displayName: 'Adaptive Banners',
            hashName: '#adaptive-banners',
            level: 1,
        },
        {
            displayName: 'Stopping and Starting Auto-Refresh',
            hashName: '#stopping-and-starting-auto-refresh',
            level: 1,
        },
    ]
}

export const ANDROID_NATIVE_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/ad-formats/native-templates' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Templates API",
            "hashName":"#templates-api",
            "level":"1"
        },
        {
            "displayName":"Loading a Native Ad",
            "hashName":"#loading-a-native-ad",
            "level":"1"
        },
        {
            "displayName":"Asset Sizes",
            "hashName":"#asset-sizes",
            "level":"1"
        },
        {
            "displayName":"How to Get the Media Content Aspect Ratio",
            "hashName":"#how-to-get-the-media-content-aspect-ratio",
            "level":"2"
        },
        {
            "displayName":"Supported Adapter Versions",
            "hashName":"#supported-adapter-versions-(native-ads,-manual)",
            "level":"1"
        },
        {
            "displayName":"Star Rating",
            "hashName":"#star-rating",
            "level":"1"
        }
    ]` )
}

export const REACT_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/react-native/ad-formats/native-manual' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Declare React Native UI Components",
            "hashName":"#declare-react-native-ui-components",
            "level":"1"
        },
        {
            "displayName":"Ad Reloading",
            "hashName":"#ad-reloading",
            "level":"1"
        },
        {
            "displayName":"Asset Sizes",
            "hashName":"#asset-sizes",
            "level":"1"
        },
        {
            "displayName":"How to Get the Media Content Aspect Ratio",
            "hashName":"#how-to-get-the-media-content-aspect-ratio",
            "level":"2"
        },
        {
            "displayName":"Supported Adapter Versions",
            "hashName":"#supported-adapter-versions",
            "level":"2"
        },
        {
            "displayName":"Star Rating",
            "hashName":"#star-rating",
            "level":"1"
        }
    ]` )
}

export const ANDROID_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/ad-formats/native-manual' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Manual API",
            "hashName":"#manual-api",
            "level":"1"
        },
        {
            "displayName":"Bind UI Components",
            "hashName":"#bind-ui-components",
            "level":"2"
        },
        {
            "displayName":"Load the Native Ad",
            "hashName":"#load-the-native-ad",
            "level":"2"
        },
        {
            "displayName":"Destroy the Native Ad",
            "hashName":"#destroy-the-native-ad",
            "level":"2"
        },
        {
            "displayName":"Asset Sizes",
            "hashName":"#asset-sizes",
            "level":"1"
        },
        {
            "displayName":"How to Get the Media Content Aspect Ratio",
            "hashName":"#how-to-get-the-media-content-aspect-ratio",
            "level":"2"
        },
        {
            "displayName":"Supported Adapter Versions",
            "hashName":"#supported-adapter-versions-(native-ads,-manual)",
            "level":"1"
        },
        {
            "displayName":"Star Rating",
            "hashName":"#star-rating",
            "level":"1"
        }
    ]` )
}
export const ANDROID_NATIVE_AD_PLACER_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/ad-formats/native-ad-placer' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Ad Placer API",
            "hashName":"#ad-placer-api",
            "level":"1"
        },
        {
            "displayName":"1. Set Up Native Ad Layout",
            "hashName":"#1.-set-up-native-ad-layout",
            "level":"1"
        },
        {
            "displayName":"2. Create Ad Placer Settings",
            "hashName":"#2.-create-ad-placer-settings",
            "level":"1"
        },
        {
            "displayName":"Configure Ad Positions",
            "hashName":"#configure-ad-positions",
            "level":"2"
        },
        {
            "displayName":"Additional Settings",
            "hashName":"#additional-settings",
            "level":"2"
        },
        {
            "displayName":"3. Set Up Ad Placer",
            "hashName":"#3.-set-up-ad-placer",
            "level":"1"
        },
        {
            "displayName":"Using MaxRecyclerAdapter",
            "hashName":"#using-maxrecycleradapter",
            "level":"2"
        },
        {
            "displayName":"4. Configure Ad Rendering Settings",
            "hashName":"#4.-configure-ad-rendering-settings",
            "level":"1"
        },
        {
            "displayName":"Templates",
            "hashName":"#templates",
            "level":"2"
        },
        {
            "displayName":"Manual",
            "hashName":"#manual",
            "level":"2"
        },
        {
            "displayName":"5. Optionally Set Listener",
            "hashName":"#5.-optionally-set-listener",
            "level":"1"
        }
    ]` )
}

export const ANDROID_PRIVACY_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/android/getting-started/privacy',
    ],
    rightMenuNavs: [
        {
            displayName: 'Consent and Age-Related Flags in GDPR and Other Regions',
            hashName: '#consent-and-age-related-flags-in-gdpr-and-other-regions',
            level: 1,
        },
        {
            displayName: 'TCF v2 Consent',
            hashName: '#tcf-v2-consent',
            level: 1,
        },
        {
            displayName: 'Prohibition on Ads to, and Personal Information from, Children and Apps Exclusively Designed for, or Exclusively Directed to, Children',
            hashName: '#prohibition-on-ads-to,-and-personal-information-from,-children-and-apps-exclusively-designed-for,-or-exclusively-directed-to,-children',
            level: 1,
        },
        {
            displayName: 'Multi-State Consumer Privacy Laws',
            hashName: '#multi-state-consumer-privacy-laws',
            level: 1,
        },
        {
            displayName: 'Meta Audience Network Data Processing Options for Users in California',
            hashName: '#meta-audience-network-data-processing-options-for-users-in-california',
            level: 1,
        },
        {
            displayName: 'Google Play Families Policy',
            hashName: '#google-play-families-policy',
            level: 1,
        }
    ]
}

export const BICF_PRIVACY_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/flutter/getting-started/privacy',
        '/documentation/mediation/godot/getting-started/privacy',
        '/documentation/mediation/react-native/getting-started/privacy',
        '/documentation/mediation/unity/getting-started/privacy',
    ],
    rightMenuNavs: [
        {
            displayName: 'Consent and Age-Related Flags in GDPR and Other Regions',
            hashName: '#consent-and-age-related-flags-in-gdpr-and-other-regions',
            level: 1,
        },
        {
            displayName: 'TCF v2 Consent',
            hashName: '#tcf-v2-consent',
            level: 1,
        },
        {
            displayName: 'Prohibition on Ads to, and Personal Information from, Children and Apps Exclusively Designed for, or Exclusively Directed to, Children',
            hashName: '#prohibition-on-ads-to,-and-personal-information-from,-children-and-apps-exclusively-designed-for,-or-exclusively-directed-to,-children',
            level: 1,
        },
        {
            displayName: 'Multi-State Consumer Privacy Laws',
            hashName: '#multi-state-consumer-privacy-laws',
            level: 1,
        },
        {
            displayName: 'Meta Audience Network Data Processing Options for Users in California',
            hashName: '#meta-audience-network-data-processing-options-for-users-in-california',
            level: 1,
        }
    ]
}

export const PRIVACY_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/getting-started/privacy',
        '/documentation/mediation/cordova/getting-started/privacy',
        '/documentation/mediation/defold/getting-started/privacy',
        '/documentation/mediation/ios/getting-started/privacy',
        '/documentation/mediation/unreal/getting-started/privacy',
    ],
    rightMenuNavs: [
        {
            displayName: 'Consent and Age-Related Flags in GDPR and Other Regions',
            hashName: '#consent-and-age-related-flags-in-gdpr-and-other-regions',
            level: 1,
        },
        {
            displayName: 'TCF v2 Consent',
            hashName: '#tcf-v2-consent',
            level: 1,
        },
        {
            displayName: 'Prohibition on Ads to, and Personal Information from, Children and Apps Exclusively Designed for, or Exclusively Directed to, Children',
            hashName: '#prohibition-on-ads-to,-and-personal-information-from,-children-and-apps-exclusively-designed-for,-or-exclusively-directed-to,-children',
            level: 1,
        },
        {
            displayName: 'Multi-State Consumer Privacy Laws',
            hashName: '#multi-state-consumer-privacy-laws',
            level: 1,
        },
        {
            displayName: 'Meta Audience Network Data Processing Options for Users in California',
            hashName: '#meta-audience-network-data-processing-options-for-users-in-california',
            level: 1,
        }
    ]
}

export const ADOBE_ERROR_CODE_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/adobe-air/getting-started/errorcodes' ],
    rightMenuNavs: [
        {
            displayName: 'Error Object',
            hashName: '#error-object',
            level: 1,
        },
        {
            displayName: 'Max Error Codes',
            hashName: '#max-error-codes',
            level: 1,
        },
        {
            displayName: 'Error Codes from Various Networks',
            hashName: '#error-codes-from-various-networks',
            level: 1,
        },
    ]
}
export const ERROR_CODE_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/getting-started/errorcodes',
        '/documentation/mediation/cordova/getting-started/errorcodes',
        '/documentation/mediation/defold/getting-started/errorcodes',
        '/documentation/mediation/flutter/getting-started/errorcodes',
        '/documentation/mediation/godot/getting-started/errorcodes',
        '/documentation/mediation/ios/getting-started/errorcodes',
        '/documentation/mediation/react-native/getting-started/errorcodes',
        '/documentation/mediation/unity/getting-started/errorcodes',
        '/documentation/mediation/unreal/getting-started/errorcodes'
    ],
    rightMenuNavs: [
        {
            displayName: 'Error Object',
            hashName: '#error-object',
            level: 1,
        },
        {
            displayName: 'MAX Error Codes',
            hashName: '#max-error-codes',
            level: 1,
        },
        {
            displayName: 'Error Codes from Various Networks',
            hashName: '#error-codes-from-various-networks',
            level: 1,
        },
    ]
}
export const ANDROID_DATA_PASSING_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/getting-started/data-passing' ],
    rightMenuNavs: [
        {
            displayName: 'Data and Keyword Passing',
            hashName: '#data-and-keyword-passing',
            level: 1,
        },
        {
            displayName: 'Data Fields',
            hashName: '#data-fields',
            level: 2,
        },
        {
            displayName: 'Location Passing',
            hashName: '#location-passing',
            level: 1,
        },
        {
            displayName: 'Content URL Passing',
            hashName: '#content-url-passing',
            level: 1,
        },
        {
            displayName: 'Unified Identifiers',
            hashName: '#unified-identifiers',
            level: 1,
        }
    ]
}
export const ANDROID_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/getting-started/advanced-settings' ],
    rightMenuNavs: [
        {
            displayName: 'Ad Placements',
            hashName: '#ad-placements',
            level: 1,
        },
        {
            displayName: 'Banners / MRECs',
            hashName: '#banners-/-mrecs',
            level: 2,
        },
        {
            displayName: 'Interstitials',
            hashName: '#interstitials',
            level: 2,
        },
        {
            displayName: 'Rewarded Ads',
            hashName: '#rewarded-ads',
            level: 2,
        },
        {
            displayName: 'Native Ads',
            hashName: '#native-ads',
            level: 2,
        },
        {
            displayName: 'Mute Audio',
            hashName: '#mute-audio',
            level: 1,
        },
        {
            displayName: 'Enable Verbose Logging',
            hashName: '#enable-verbose-logging',
            level: 1
        },
        {
            displayName: 'Programmatically',
            hashName: '#programmatically',
            level: 2,
        },
        {
            displayName: 'Android Manifest',
            hashName: '#android-manifest',
            level: 2,
        },
        {
            displayName: 'Segment Name',
            hashName: '#segment-name',
            level: 1,
        },
        {
            displayName: 'Creative ID and Network Name',
            hashName: '#creative-id-and-network-name',
            level: 1,
        },
        {
            displayName: 'DSP Name',
            hashName: '#dsp-name',
            level: 1,
        },
        {
            displayName: 'Impression-Level User Revenue API',
            hashName: '#impression-level-user-revenue-api',
            level: 1,
        },
        {
            displayName: 'Establishing Ad Request Callbacks',
            hashName: '#establishing-ad-request-callbacks',
            level: 1,
        },
        {
            displayName: 'Selective Init',
            hashName: '#selective-init',
            level: 1,
        },
        {
            displayName: 'Waterfall Information API',
            hashName: '#waterfall-information-api',
            level: 1,
        },
        {
            displayName: 'Customize Banner / MREC Ad Refresh',
            hashName: '#customize-banner-/-mrec-ad-refresh',
            level: 1,
        },
    ]
}
export const ANDROID_MEDIATION_ADAPTER_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/mediation-adapters' ],
    rightMenuNavs: [
        {
            displayName: 'Gradle',
            hashName: '#gradle',
            level: 1,
        },
        {
            displayName: 'Adapter Network Information',
            hashName: '#adapter-network-information',
            level: 1,
        },
    ]
}
export const ANDROID_MANUAL_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/manual-integration-android' ],
    rightMenuNavs: [
        {
            displayName: 'Getting Started',
            hashName: '#getting-started',
            level: 1,
        },
        {
            displayName: 'Download the Latest Android SDK',
            hashName: '#',
            level: 1,
        },
        {
            displayName: 'Add the SDK to the Project',
            hashName: '#add-the-sdk-to-the-project',
            level: 1,
        },
        {
            displayName: 'Gradle',
            hashName: '#gradle',
            level: 1,
        },
        {
            displayName: 'Enable Ad Review',
            hashName: '#enable-ad-review',
            level: 1,
        },
        {
            displayName: 'Add the SDK Key',
            hashName: '#add-the-sdk-key',
            level: 1,
        },
        {
            displayName: 'Initialize the SDK',
            hashName: '#initialize-the-sdk',
            level: 1,
        },
        {
            displayName: 'Interstitial Ads',
            hashName: '#interstitial-ads',
            level: 1,
        },
        {
            displayName: 'Rewarded Ads',
            hashName: '#rewarded-ads',
            level: 1,
        },
        {
            displayName: 'Banners & MRECs',
            hashName: '#banners-&-mrecs',
            level: 1,
        },
        {
            displayName: 'Preparing Mediated Networks',
            hashName: '#preparing-mediated-networks',
            level: 1,
        },
        {
            displayName: 'Manual Download for MAX Mediation Networks',
            hashName: '#manual-download-for-max-mediation-networks',
            level: 1,
        },
    ]
}

export const ACCOUNT_INFO_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ui-max/account/general-account-info' ],
    rightMenuNavs: [
        {
            displayName: 'Keys',
            hashName: '#keys',
            level: 1,
        },
        {
            displayName: 'Two-Step Verification',
            hashName: '#two-step-verification',
            level: 1,
        },
    ]
}

export const APP_ADS_TXT_INFO_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ui-max/account/app-ads-txt-info' ],
    rightMenuNavs: [
        {
            displayName: 'Implementing an app-ads.txt File',
            hashName: '#implementing-an-app-ads.txt-file',
            level: 1,
        },
        {
            displayName: 'Best Practices',
            hashName: '#best-practices',
            level: 1,
        },
    ]
}

export const PAYMENTS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ui-max/account/payments' ],
    rightMenuNavs: [
        {
            displayName: 'How to Set Up Payment Information',
            hashName: '#how-to-set-up-payment-information',
            level: 1,
        },
        {
            displayName: 'Payment Methods',
            hashName: '#payment-methods',
            level: 1,
        },
        {
            displayName: 'Payment Schedule and Minimum Thresholds',
            hashName: '#payment-schedule-and-minimum-thresholds',
            level: 1,
        },
        {
            displayName: 'Estimating Your AppLovin Payment',
            hashName: '#estimating-your-applovin-payment',
            level: 1,
        },
        {
            displayName: 'Payment Invoices and History',
            hashName: '#payment-invoices-and-history',
            level: 1,
        },
        {
            displayName: 'Frequently Asked Questions',
            hashName: '#frequently-asked-questions',
            level: 1,
        },
    ]
}

export const BEST_PRACTICES_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ui-max/account/best-practices' ],
    rightMenuNavs: [
        {
            displayName: 'Before You Set Up Your Account',
            hashName: '#before-you-set-up-your-account',
            level: 1,
        },
        {
            displayName: 'Integration Best Practices',
            hashName: '#integration-best-practices',
            level: 1,
        },
        {
            displayName: 'Account Best Practices',
            hashName: '#account-best-practices',
            level: 1,
        },
        {
            displayName: 'Live App Best Practices',
            hashName: '#live-app-best-practices',
            level: 1,
        },
    ]
}

export const ADVANCED_SETUP_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ui-max/ad-units/advanced-setup' ],
    rightMenuNavs: [
        {
            displayName: 'Waterfall Segmentation and Cloning',
            hashName: '#waterfall-segmentation-and-cloning',
            level: 1,
        },
        {
            displayName: 'Direct Sold',
            hashName: '#direct-sold',
            level: 1,
        },
        {
            displayName: 'A/B Testing',
            hashName: '#a/b-testing',
            level: 1,
        },
    ]
}

export const WATERFALL_MGMT_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ui-max/ad-units/waterfall-management-tools' ],
    rightMenuNavs: [
        {
            displayName: 'Ad Unit Management API',
            hashName: '#ad-unit-management-api',
            level: 1,
        },
        {
            displayName: 'Ad Unit Manager CSV Tool',
            hashName: '#ad-unit-manager-csv-tool',
            level: 1,
        },
    ]
}

export const FACEBOOK_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/facebook',
        '/documentation/mediation/android/mediation-setup/facebook',
        '/documentation/mediation/cordova/mediation-setup/facebook',
        '/documentation/mediation/defold/mediation-setup/facebook',
        '/documentation/mediation/flutter/mediation-setup/facebook',
        '/documentation/mediation/godot/mediation-setup/facebook',
        '/documentation/mediation/ios/mediation-setup/facebook',
        '/documentation/mediation/react-native/mediation-setup/facebook',
        '/documentation/mediation/unity/mediation-setup/facebook',
        '/documentation/mediation/unreal/mediation-setup/facebook'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Meta for Developers Account',
            hashName: '#step-1.-create-a-meta-for-developers-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Ad Units in the Monetization Manager',
            hashName: '#step-2.-create-an-application-and-ad-units-in-the-monetization-manager',
            level: 1,
        },
        {
            displayName: 'Choose Your Platform and Display Format',
            hashName: '#choose-your-platform-and-display-format',
            level: 2,
        },
        {
            displayName: 'Create Ad Space',
            hashName: '#create-ad-space',
            level: 2,
        },
        {
            displayName: 'Create Ad Placement',
            hashName: '#create-ad-placement',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Meta Audience Network in Your MAX Account',
            hashName: '#step-3.-enable-meta-audience-network-in-your-max-account',
            level: 1,
        },
    ]
}
export const INMOBI_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/inmobi',
        '/documentation/mediation/android/mediation-setup/inmobi',
        '/documentation/mediation/cordova/mediation-setup/inmobi',
        '/documentation/mediation/defold/mediation-setup/inmobi',
        '/documentation/mediation/flutter/mediation-setup/inmobi',
        '/documentation/mediation/godot/mediation-setup/inmobi',
        '/documentation/mediation/ios/mediation-setup/inmobi',
        '/documentation/mediation/react-native/mediation-setup/inmobi',
        '/documentation/mediation/unity/mediation-setup/inmobi',
        '/documentation/mediation/unreal/mediation-setup/inmobi'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create an InMobi Account',
            hashName: '#step-1.-create-an-inmobi-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in InMobi',
            hashName: '#step-2.-create-an-application-and-placements-in-inmobi',
            level: 1,
        },
        {
            displayName: 'Step 3. Enable InMobi in Your MAX Account',
            hashName: '#step-3.-enable-inmobi-in-your-max-account',
            level: 1,
        },
    ]
}
export const MINTEGRAL_INTERGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/mintegral',
        '/documentation/mediation/android/mediation-setup/mintegral',
        '/documentation/mediation/cordova/mediation-setup/mintegral',
        '/documentation/mediation/defold/mediation-setup/mintegral',
        '/documentation/mediation/flutter/mediation-setup/mintegral',
        '/documentation/mediation/godot/mediation-setup/mintegral',
        '/documentation/mediation/ios/mediation-setup/mintegral',
        '/documentation/mediation/react-native/mediation-setup/mintegral',
        '/documentation/mediation/unity/mediation-setup/mintegral',
        '/documentation/mediation/unreal/mediation-setup/mintegral'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Mintegral Account',
            hashName: '#step-1.-create-a-mintegral-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Ad Unit in Mintegral',
            hashName: '#step-2.-create-an-application-and-ad-unit-in-mintegral',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Create Ad Placements & Units',
            hashName: '#create-ad-placements-&-units',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Mintegral in Your MAX Account',
            hashName: '#step-3.-enable-mintegral-in-your-max-account',
            level: 1,
        },
    ]
}
export const PANGLE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/pangle',
        '/documentation/mediation/android/mediation-setup/pangle',
        '/documentation/mediation/cordova/mediation-setup/pangle',
        '/documentation/mediation/defold/mediation-setup/pangle',
        '/documentation/mediation/flutter/mediation-setup/pangle',
        '/documentation/mediation/godot/mediation-setup/pangle',
        '/documentation/mediation/ios/mediation-setup/pangle',
        '/documentation/mediation/react-native/mediation-setup/pangle',
        '/documentation/mediation/unity/mediation-setup/pangle',
        '/documentation/mediation/unreal/mediation-setup/pangle'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Pangle Account',
            hashName: '#step-1.-create-a-pangle-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in Pangle',
            hashName: '#step-2.-create-an-application-and-placements-in-pangle',
            level: 1,
        }, {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Create Ad Units',
            hashName: '#create-ad-units',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Pangle in Your MAX Account',
            hashName: '#step-3.-enable-pangle-in-your-max-account',
            level: 1,
        },
    ]
}
export const SMAATO_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/smaato',
        '/documentation/mediation/android/mediation-setup/smaato',
        '/documentation/mediation/cordova/mediation-setup/smaato',
        '/documentation/mediation/defold/mediation-setup/smaato',
        '/documentation/mediation/flutter/mediation-setup/smaato',
        '/documentation/mediation/godot/mediation-setup/smaato',
        '/documentation/mediation/ios/mediation-setup/smaato',
        '/documentation/mediation/react-native/mediation-setup/smaato',
        '/documentation/mediation/unity/mediation-setup/smaato',
        '/documentation/mediation/unreal/mediation-setup/smaato'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Smaato Ad Network Account',
            hashName: '#step-1.-create-a-smaato-ad-network-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in Smaato',
            hashName: '#step-2.-create-an-application-and-placements-in-smaato',
            level: 1,
        },
        {
            displayName: 'Step 3. Enable Smaato in Your MAX Account',
            hashName: '#step-3.-enable-smaato-in-your-max-account',
            level: 1,
        },
    ]
}
export const VERVE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/verve',
        '/documentation/mediation/android/mediation-setup/verve',
        '/documentation/mediation/cordova/mediation-setup/verve',
        '/documentation/mediation/defold/mediation-setup/verve',
        '/documentation/mediation/flutter/mediation-setup/verve',
        '/documentation/mediation/godot/mediation-setup/verve',
        '/documentation/mediation/ios/mediation-setup/verve',
        '/documentation/mediation/react-native/mediation-setup/verve',
        '/documentation/mediation/unity/mediation-setup/verve',
        '/documentation/mediation/unreal/mediation-setup/verve'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a PubNative Publisher Account',
            hashName: '#step-1.-create-a-pubnative-publisher-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Activate Your Account',
            hashName: '#step-2.-activate-your-account',
            level: 1,
        },
        {
            displayName: 'Step 3. Enable Verve in Your MAX Account',
            hashName: '#step-3.-enable-verve-in-your-max-account',
            level: 1,
        },
    ]
}
export const VUNGLE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/liftoff',
        '/documentation/mediation/android/mediation-setup/liftoff',
        '/documentation/mediation/cordova/mediation-setup/liftoff',
        '/documentation/mediation/defold/mediation-setup/liftoff',
        '/documentation/mediation/flutter/mediation-setup/liftoff',
        '/documentation/mediation/godot/mediation-setup/liftoff',
        '/documentation/mediation/ios/mediation-setup/liftoff',
        '/documentation/mediation/react-native/mediation-setup/liftoff',
        '/documentation/mediation/unity/mediation-setup/liftoff',
        '/documentation/mediation/unreal/mediation-setup/liftoff'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Liftoff Account',
            hashName: '#step-1.-create-a-liftoff-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in Liftoff Monetize',
            hashName: '#step-2.-create-an-application-and-placements-in-liftoff-monetize',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Create a Placement',
            hashName: '#create-a-placement',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Liftoff Monetize in Your MAX Account',
            hashName: '#step-3.-enable-liftoff-monetize-in-your-max-account',
            level: 1,
        },
    ]
}

export const AMAZON_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/mediation-setup/amazon',
        '/documentation/mediation/ios/mediation-setup/amazon',
        '/documentation/mediation/unity/mediation-setup/amazon'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create an Amazon Account',
            hashName: '#step-1.-create-an-amazon-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application in Amazon Publisher Services Portal',
            hashName: '#step-2.-create-an-application-in-amazon-publisher-services-portal',
            level: 1,
        },
        {
            displayName: 'Step 3. Upload Your Price Point Mapping',
            hashName: '#step-3.-upload-your-price-point-mapping',
            level: 1,
        },
        {
            displayName: 'Step 4. Add Amazon Publisher Services Entries in Your app-ads.txt File',
            hashName: '#step-4.-add-amazon-publisher-services-entries-in-your-app-ads.txt-file',
            level: 1,
        },
    ]
}

export const GOOGLE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/google',
        '/documentation/mediation/android/mediation-setup/google',
        '/documentation/mediation/cordova/mediation-setup/google',
        '/documentation/mediation/defold/mediation-setup/google',
        '/documentation/mediation/flutter/mediation-setup/google',
        '/documentation/mediation/godot/mediation-setup/google',
        '/documentation/mediation/ios/mediation-setup/google',
        '/documentation/mediation/react-native/mediation-setup/google',
        '/documentation/mediation/unity/mediation-setup/google',
        '/documentation/mediation/unreal/mediation-setup/google'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create an AdMob Account',
            hashName: '#step-1.-create-an-admob-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Ad Units in AdMob',
            hashName: '#step-2.-create-an-application-and-ad-units-in-admob',
            level: 1,
        },
        {
            displayName: 'Step 3. Enable Google Bidding in Your MAX Account',
            hashName: '#step-3.-enable-google-bidding-in-your-max-account',
            level: 1,
        },
    ]
}

export const ADMOB_INTERGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/admob',
        '/documentation/mediation/android/mediation-setup/admob',
        '/documentation/mediation/cordova/mediation-setup/admob',
        '/documentation/mediation/defold/mediation-setup/admob',
        '/documentation/mediation/flutter/mediation-setup/admob',
        '/documentation/mediation/godot/mediation-setup/admob',
        '/documentation/mediation/ios/mediation-setup/admob',
        '/documentation/mediation/react-native/mediation-setup/admob',
        '/documentation/mediation/unity/mediation-setup/admob',
        '/documentation/mediation/unreal/mediation-setup/admob'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create an AdMob Account',
            hashName: '#step-1.-create-an-admob-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Ad Units in AdMob',
            hashName: '#step-2.-create-an-application-and-ad-units-in-admob',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Banner/MREC',
            hashName: '#banner/mrec',
            level: 2,
        },
        {
            displayName: 'Native Banners/Native MREC',
            hashName: '#native-banners/native-mrec',
            level: 2,
        },
        {
            displayName: 'Interstitial',
            hashName: '#interstitial',
            level: 2,
        },
        {
            displayName: 'Rewarded Video',
            hashName: '#rewarded-video',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable AdMob in Your MAX Account',
            hashName: '#step-3.-enable-admob-in-your-max-account',
            level: 1,
        },
        {
            displayName: 'Content URL Mapping Support',
            hashName: '#content-url-mapping-support',
            level: 1,
        },
        {
            displayName: 'Single-Content URL Mapping',
            hashName: '#single-content-url-mapping',
            level: 2,
        },
        {
            displayName: 'Multi-Content URL Mapping',
            hashName: '#multi-content-url-mapping',
            level: 2,
        },
    ]
}
export const CHARTBOOT_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/chartboost',
        '/documentation/mediation/android/mediation-setup/chartboost',
        '/documentation/mediation/cordova/mediation-setup/chartboost',
        '/documentation/mediation/defold/mediation-setup/chartboost',
        '/documentation/mediation/flutter/mediation-setup/chartboost',
        '/documentation/mediation/godot/mediation-setup/chartboost',
        '/documentation/mediation/ios/mediation-setup/chartboost',
        '/documentation/mediation/react-native/mediation-setup/chartboost',
        '/documentation/mediation/unity/mediation-setup/chartboost',
        '/documentation/mediation/unreal/mediation-setup/chartboost'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Chartboost Account',
            hashName: '#step-1.-create-a-chartboost-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and a Campaign in Chartboost',
            hashName: '#step-2.-create-an-application-and-a-campaign-in-chartboost',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Start a New Campaign',
            hashName: '#start-a-new-campaign',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Chartboost in Your MAX Account',
            hashName: '#step-3.-enable-chartboost-in-your-max-account',
            level: 1,
        },
    ]
}

export const CSJ_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/csj',
        '/documentation/mediation/cordova/mediation-setup/csj',
        '/documentation/mediation/defold/mediation-setup/csj',
        '/documentation/mediation/flutter/mediation-setup/csj',
        '/documentation/mediation/godot/mediation-setup/csj',
        '/documentation/mediation/ios/mediation-setup/csj',
        '/documentation/mediation/react-native/mediation-setup/csj',
        '/documentation/mediation/unity/mediation-setup/csj',
        '/documentation/mediation/unreal/mediation-setup/csj'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a CSJ Account',
            hashName: '#step-1.-create-a-csj-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in CSJ',
            hashName: '#step-2.-create-an-application-and-placements-in-csj',
            level: 1,
        },
        {
            displayName: 'Step 3. Enable CSJ in Your MAX Account',
            hashName: '#step-3.-enable-csj-in-your-max-account',
            level: 1,
        },
    ]
}

export const FYBERMARKETPLACE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/fyber-marketplace',
        '/documentation/mediation/android/mediation-setup/fyber-marketplace',
        '/documentation/mediation/cordova/mediation-setup/fyber-marketplace',
        '/documentation/mediation/defold/mediation-setup/fyber-marketplace',
        '/documentation/mediation/flutter/mediation-setup/fyber-marketplace',
        '/documentation/mediation/godot/mediation-setup/fyber-marketplace',
        '/documentation/mediation/ios/mediation-setup/fyber-marketplace',
        '/documentation/mediation/react-native/mediation-setup/fyber-marketplace',
        '/documentation/mediation/unity/mediation-setup/fyber-marketplace',
        '/documentation/mediation/unreal/mediation-setup/fyber-marketplace'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a DT Exchange Account',
            hashName: '#step-1.-create-a-dt-exchange-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application in DT Exchange',
            hashName: '#step-2.-create-an-application-in-dt-exchange',
            level: 1,
        },
        {
            displayName: 'Step 3. Create a Placement in DT Exchange',
            hashName: '#step-3.-create-a-placement-in-dt-exchange',
            level: 1,
        },
        {
            displayName: 'Step 4. Enable DT Exchange in Your MAX Account',
            hashName: '#step-4.-enable-dt-exchange-in-your-max-account',
            level: 1,
        },
    ]
}

export const HYPRMX_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/hyprmx',
        '/documentation/mediation/android/mediation-setup/hyprmx',
        '/documentation/mediation/cordova/mediation-setup/hyprmx',
        '/documentation/mediation/defold/mediation-setup/hyprmx',
        '/documentation/mediation/flutter/mediation-setup/hyprmx',
        '/documentation/mediation/godot/mediation-setup/hyprmx',
        '/documentation/mediation/ios/mediation-setup/hyprmx',
        '/documentation/mediation/react-native/mediation-setup/hyprmx',
        '/documentation/mediation/unity/mediation-setup/hyprmx',
        '/documentation/mediation/unreal/mediation-setup/hyprmx'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create an HyprMX Account',
            hashName: '#step-1.-create-an-hyprmx-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in HyprMX',
            hashName: '#step-2.-create-an-application-and-placements-in-hyprmx',
            level: 1,
        },
        {
            displayName: 'Step 3. Enable HyprMX in Your MAX Account',
            hashName: '#step-3.-enable-hyprmx-in-your-max-account',
            level: 1,
        },
    ]
}

export const CUSTOM_SDK_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/custom-sdk',
        '/documentation/mediation/android/mediation-setup/custom-sdk',
        '/documentation/mediation/cordova/mediation-setup/custom-sdk',
        '/documentation/mediation/defold/mediation-setup/custom-sdk',
        '/documentation/mediation/ios/mediation-setup/custom-sdk',
        '/documentation/mediation/flutter/mediation-setup/custom-sdk',
        '/documentation/mediation/godot/mediation-setup/custom-sdk',
        '/documentation/mediation/react-native/mediation-setup/custom-sdk',
        '/documentation/mediation/unity/mediation-setup/custom-sdk',
        '/documentation/mediation/unreal/mediation-setup/custom-sdk'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Add Custom SDK Network Settings',
            hashName: '#step-1.-add-custom-sdk-network-settings',
            level: 1,
        },
        {
            displayName: 'Step 2. Enable the Custom SDK Network',
            hashName: '#step-2.-enable-the-custom-sdk-network',
            level: 1,
        },
    ],
}

export const TENCENT_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/tencent',
        '/documentation/mediation/android/mediation-setup/tencent',
        '/documentation/mediation/cordova/mediation-setup/tencent',
        '/documentation/mediation/defold/mediation-setup/tencent',
        '/documentation/mediation/flutter/mediation-setup/tencent',
        '/documentation/mediation/godot/mediation-setup/tencent',
        '/documentation/mediation/ios/mediation-setup/tencent',
        '/documentation/mediation/react-native/mediation-setup/tencent',
        '/documentation/mediation/unity/mediation-setup/tencent',
        '/documentation/mediation/unreal/mediation-setup/tencent'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Tencent Ad Network Account',
            hashName: '#step-1.-create-a-tencent-ad-network-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in Tencent',
            hashName: '#step-2.-create-an-application-and-placements-in-tencent',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Tencent in Your MAX Account',
            hashName: '#step-3.-enable-tencent-in-your-max-account',
            level: 1,
        },
    ]
}
export const IRONSOURCE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/ironsource',
        '/documentation/mediation/android/mediation-setup/ironsource',
        '/documentation/mediation/cordova/mediation-setup/ironsource',
        '/documentation/mediation/defold/mediation-setup/ironsource',
        '/documentation/mediation/flutter/mediation-setup/ironsource',
        '/documentation/mediation/godot/mediation-setup/ironsource',
        '/documentation/mediation/ios/mediation-setup/ironsource',
        '/documentation/mediation/react-native/mediation-setup/ironsource',
        '/documentation/mediation/unity/mediation-setup/ironsource',
        '/documentation/mediation/unreal/mediation-setup/ironsource'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create an IronSource Account',
            hashName: '#step-1.-create-an-ironsource-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application in IronSource',
            hashName: '#step-2.-create-an-application-in-ironsource',
            level: 1,
        }, {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'IronSource Instances',
            hashName: '#ironsource-instances',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable IronSource in Your MAX Account',
            hashName: '#step-3.-enable-ironsource-in-your-max-account',
            level: 1,
        },
    ]
}
export const LINE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/line',
        '/documentation/mediation/android/mediation-setup/line',
        '/documentation/mediation/cordova/mediation-setup/line',
        '/documentation/mediation/defold/mediation-setup/line',
        '/documentation/mediation/flutter/mediation-setup/line',
        '/documentation/mediation/godot/mediation-setup/line',
        '/documentation/mediation/ios/mediation-setup/line',
        '/documentation/mediation/react-native/mediation-setup/line',
        '/documentation/mediation/unity/mediation-setup/line',
        '/documentation/mediation/unreal/mediation-setup/line'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a LINE Account',
            hashName: '#step-1.-create-a-line-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in LINE',
            hashName: '#step-2.-create-an-application-and-placements-in-line',
            level: 1,
        }, {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Add a New Slot',
            hashName: '#add-a-new-slot',
            level: 2,
        },
        {
            displayName: 'Get Your App ID and Slot ID',
            hashName: '#get-your-app-id-and-slot-id',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable LINE in Your MAX Account',
            hashName: '#step-3.-enable-line-in-your-max-account',
            level: 1,
        },
    ]
}
export const MAIO_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/maio',
        '/documentation/mediation/android/mediation-setup/maio',
        '/documentation/mediation/cordova/mediation-setup/maio',
        '/documentation/mediation/defold/mediation-setup/maio',
        '/documentation/mediation/flutter/mediation-setup/maio',
        '/documentation/mediation/godot/mediation-setup/maio',
        '/documentation/mediation/ios/mediation-setup/maio',
        '/documentation/mediation/react-native/mediation-setup/maio',
        '/documentation/mediation/unity/mediation-setup/maio',
        '/documentation/mediation/unreal/mediation-setup/maio'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Maio Account',
            hashName: '#step-1.-create-a-maio-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in Maio',
            hashName: '#step-2.-create-an-application-and-placements-in-maio',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Add a New Placement',
            hashName: '#add-a-new-placement',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Maio in Your MAX Account',
            hashName: '#step-3.-enable-maio-in-your-max-account',
            level: 1,
        },
    ]
}

export const MYTARGET_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/vkadnetwork',
        '/documentation/mediation/android/mediation-setup/vkadnetwork',
        '/documentation/mediation/cordova/mediation-setup/vkadnetwork',
        '/documentation/mediation/defold/mediation-setup/vkadnetwork',
        '/documentation/mediation/flutter/mediation-setup/vkadnetwork',
        '/documentation/mediation/godot/mediation-setup/vkadnetwork',
        '/documentation/mediation/ios/mediation-setup/vkadnetwork',
        '/documentation/mediation/react-native/mediation-setup/vkadnetwork',
        '/documentation/mediation/unity/mediation-setup/vkadnetwork',
        '/documentation/mediation/unreal/mediation-setup/vkadnetwork'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a VK Ad Network Account',
            hashName: '#step-1.-create-a-vk-ad-network-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in VK Ad Network',
            hashName: '#step-2.-create-an-application-and-placements-in-vk-ad-network',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Add a New Placement',
            hashName: '#add-a-new-placement',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable VK Ad Network in Your MAX Account',
            hashName: '#step-3.-enable-vk-ad-network-in-your-max-account',
            level: 1,
        },
    ]
}

export const MOBILEFUSE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/mobilefuse',
        '/documentation/mediation/android/mediation-setup/mobilefuse',
        '/documentation/mediation/cordova/mediation-setup/mobilefuse',
        '/documentation/mediation/defold/mediation-setup/mobilefuse',
        '/documentation/mediation/flutter/mediation-setup/mobilefuse',
        '/documentation/mediation/godot/mediation-setup/mobilefuse',
        '/documentation/mediation/ios/mediation-setup/mobilefuse',
        '/documentation/mediation/react-native/mediation-setup/mobilefuse',
        '/documentation/mediation/unity/mediation-setup/mobilefuse',
        '/documentation/mediation/unreal/mediation-setup/mobilefuse'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Complete Your MobileFuse Contract',
            hashName: '#step-1.-complete-your-mobilefuse-contract',
            level: 1,
        },
        {
            displayName: 'Step 2. Complete the Onboarding Questionnaire',
            hashName: '#step-2.-complete-the-onboarding-questionnarie',
            level: 1,
        },
        {
            displayName: 'Step 3. Receive Account Access and Placement IDs',
            hashName: '#step-3.-receive-account-access-and-placement-ids',
            level: 1,
        },
        {
            displayName: 'Step 4. Enable MobileFuse in Your MAX Account',
            hashName: '#step-4.-enable-mobilefuse-in-your-max-account',
            level: 1,
        },
        {
            displayName: 'Best Practices',
            hashName: '#best-practices',
            level: 1,
        },
    ]
}

export const OGURY_PRESAGE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/ogury-presage',
        '/documentation/mediation/android/mediation-setup/ogury-presage',
        '/documentation/mediation/cordova/mediation-setup/ogury-presage',
        '/documentation/mediation/defold/mediation-setup/ogury-presage',
        '/documentation/mediation/flutter/mediation-setup/ogury-presage',
        '/documentation/mediation/godot/mediation-setup/ogury-presage',
        '/documentation/mediation/ios/mediation-setup/ogury-presage',
        '/documentation/mediation/react-native/mediation-setup/ogury-presage',
        '/documentation/mediation/unity/mediation-setup/ogury-presage',
        '/documentation/mediation/unreal/mediation-setup/ogury-presage'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create an Ogury Account',
            hashName: '#step-1.-create-an-ogury-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Ad Units in Ogury',
            hashName: '#step-2.-create-an-application-and-ad-units-in-ogury',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Create Ad Units',
            hashName: '#create-ad-units',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Ogury in Your MAX Account',
            hashName: '#step-3.-enable-ogury-in-your-max-account',
            level: 1,
        },
    ]
}

export const UNITYADS_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/unityads',
        '/documentation/mediation/android/mediation-setup/unityads',
        '/documentation/mediation/cordova/mediation-setup/unityads',
        '/documentation/mediation/defold/mediation-setup/unityads',
        '/documentation/mediation/flutter/mediation-setup/unityads',
        '/documentation/mediation/godot/mediation-setup/unityads',
        '/documentation/mediation/ios/mediation-setup/unityads',
        '/documentation/mediation/react-native/mediation-setup/unityads',
        '/documentation/mediation/unity/mediation-setup/unityads',
        '/documentation/mediation/unreal/mediation-setup/unityads'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Unity Ads Account',
            hashName: '#step-1.-create-a-unity-ads-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in Unity Ads',
            hashName: '#step-2.-create-an-application-and-placements-in-unity-ads',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Create a Placement',
            hashName: '#create-a-placement',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Unity Ads in Your MAX Account',
            hashName: '#step-3.-enable-unity-ads-in-your-max-account',
            level: 1,
        },
    ]
}
export const YANDEX_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/mediation-setup/yandex',
        '/documentation/mediation/android/mediation-setup/yandex',
        '/documentation/mediation/cordova/mediation-setup/yandex',
        '/documentation/mediation/defold/mediation-setup/yandex',
        '/documentation/mediation/flutter/mediation-setup/yandex',
        '/documentation/mediation/godot/mediation-setup/yandex',
        '/documentation/mediation/ios/mediation-setup/yandex',
        '/documentation/mediation/react-native/mediation-setup/yandex',
        '/documentation/mediation/unity/mediation-setup/yandex',
        '/documentation/mediation/unreal/mediation-setup/yandex'
    ],
    rightMenuNavs: [
        {
            displayName: 'Step 1. Create a Yandex Account',
            hashName: '#step-1.-create-a-yandex-account',
            level: 1,
        },
        {
            displayName: 'Step 2. Create an Application and Placements in Yandex',
            hashName: '#step-2.-create-an-application-and-placements-in-yandex',
            level: 1,
        },
        {
            displayName: 'Add Your App',
            hashName: '#add-your-app',
            level: 2,
        },
        {
            displayName: 'Add a New Placement',
            hashName: '#add-a-new-placement',
            level: 2,
        },
        {
            displayName: 'Step 3. Enable Yandex in Your MAX Account',
            hashName: '#step-3.-enable-yandex-in-your-max-account',
            level: 1,
        },
    ]
}
export const CREATIVE_DEBUGGER_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/testing-networks/creative-debugger',
        '/documentation/mediation/android/testing-networks/creative-debugger',
        '/documentation/mediation/cordova/testing-networks/creative-debugger',
        '/documentation/mediation/defold/testing-networks/creative-debugger',
        '/documentation/mediation/flutter/testing-networks/creative-debugger',
        '/documentation/mediation/godot/testing-networks/creative-debugger',
        '/documentation/mediation/ios/testing-networks/creative-debugger',
        '/documentation/mediation/react-native/testing-networks/creative-debugger',
        '/documentation/mediation/unity/testing-networks/creative-debugger',
        '/documentation/mediation/unreal/testing-networks/creative-debugger'
    ],
    rightMenuNavs: [
        {
            displayName: 'Creative ID',
            hashName: '#creative-id',
            level: 1,
        },
        {
            displayName: 'Network Name',
            hashName: '#network-name',
            level: 1,
        },
    ]
}
export const MEDIATION_DEBUGGER_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/testing-networks/mediation-debugger',
        '/documentation/mediation/android/testing-networks/mediation-debugger',
        '/documentation/mediation/cordova/testing-networks/mediation-debugger',
        '/documentation/mediation/defold/testing-networks/mediation-debugger',
        '/documentation/mediation/flutter/testing-networks/mediation-debugger',
        '/documentation/mediation/godot/testing-networks/mediation-debugger',
        '/documentation/mediation/ios/testing-networks/mediation-debugger',
        '/documentation/mediation/react-native/testing-networks/mediation-debugger',
        '/documentation/mediation/unity/testing-networks/mediation-debugger',
        '/documentation/mediation/unreal/testing-networks/mediation-debugger'
    ],
    rightMenuNavs: [
        {
            displayName: 'Displaying the Mediation Debugger',
            hashName: '#displaying-the-mediation-debugger',
            level: 1,
        },
        {
            displayName: 'Integration Status',
            hashName: '#integration-status',
            level: 1,
        },
        {
            displayName: 'Testing with Test Ads',
            hashName: '#testing-with-test-ads',
            level: 1,
        },
        {
            displayName: 'Testing with Live Ads',
            hashName: '#testing-with-live-ads',
            level: 1,
        },
        {
            displayName: 'Full Waterfall',
            hashName: '#full-waterfall',
            level: 2,
        },
        {
            displayName: 'Single Ad Source',
            hashName: '#single-ad-source',
            level: 2,
        },
        {
            displayName: 'Within the App',
            hashName: '#within-the-app',
            level: 2,
        },
        {
            displayName: 'Sharing the Mediation Debugger',
            hashName: '#sharing-the-mediation-debugger',
            level: 1,
        },
        {
            displayName: 'app-ads.txt',
            hashName: '#app-ads.txt',
            level: 1,
        },
    ]
}
export const TEST_MODE_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/testing-networks/test-mode',
        '/documentation/mediation/android/testing-networks/test-mode',
        '/documentation/mediation/cordova/testing-networks/test-mode',
        '/documentation/mediation/defold/testing-networks/test-mode',
        '/documentation/mediation/flutter/testing-networks/test-mode',
        '/documentation/mediation/godot/testing-networks/test-mode',
        '/documentation/mediation/ios/testing-networks/test-mode',
        '/documentation/mediation/react-native/testing-networks/test-mode',
        '/documentation/mediation/unity/testing-networks/test-mode',
        '/documentation/mediation/unreal/testing-networks/test-mode'
    ],
    rightMenuNavs: [
        {
            displayName: 'Enable Test Mode',
            hashName: '#enable-test-mode',
            level: 1,
        },
        {
            displayName: 'Disable Test Mode',
            hashName: '#disable-test-mode',
            level: 1,
        },
    ]
}

export const IOS_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/getting-started/integration' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Download the Latest SDK",
            "hashName":"#",
            "level":"1"
        },
        {
            "displayName":"CocoaPods (Recommended)",
            "hashName":"#cocoapods-(recommended)",
            "level":"2"
        },
        {
            "displayName":"Integrate Custom SDK Adapters",
            "hashName":"#integrate-custom-sdk-adapters",
            "level":"1"
        },
        {
            "displayName":"Enable Ad Review",
            "hashName":"#enable-ad-review",
            "level":"1"
        },
        {
            "displayName":"Add the SDK Key",
            "hashName":"#add-the-sdk-key",
            "level":"1"
        },
        {
            "displayName":"Initialize the SDK",
            "hashName":"#initialize-the-sdk",
            "level":"1"
        },
        {
            "displayName":"iOS 14 Support",
            "hashName":"#ios-14-support",
            "level":"1"
        },
        {
            "displayName":"SKAdNetwork",
            "hashName":"#skadnetwork",
            "level":"2"
        },
        {
            "displayName":"MAX Terms and Privacy Policy Flow",
            "hashName":"#max-terms-and-privacy-policy-flow",
            "level":"2"
        },
        {
            "displayName":"Consent and Data APIs",
            "hashName":"#consent-and-data-apis",
            "level":"2"
        },
        {
            "displayName":"iOS 15 Global SKAdNetwork Reporting",
            "hashName":"#ios-15-global-skadnetwork-reporting",
            "level":"1"
        }
    ]` )
}

export const ANDROID_123_MIGRATION_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/getting-started/migration123' ],
    rightMenuNavs: [
        {
            displayName: 'Create the SDK Initialization Configuration',
            hashName: '#create-the-sdk-initialization-configuration',
            level: 1,
        },
        {
            displayName: 'Initialize the SDK',
            hashName: '#initialize-the-sdk',
            level: 1,
        },
        {
            displayName: 'Example',
            hashName: '#example',
            level: 1,
        },
    ]
}

export const IOS_123_MIGRATION_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/getting-started/migration123' ],
    rightMenuNavs: [
        {
            displayName: 'Create the SDK Initialization Configuration',
            hashName: '#create-the-sdk-initialization-configuration',
            level: 1,
        },
        {
            displayName: 'Initialize the SDK',
            hashName: '#initialize-the-sdk',
            level: 1,
        },
        {
            displayName: 'Example',
            hashName: '#example',
            level: 1,
        },
    ]
}

export const IOS_APP_OPEN_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/ad-formats/app-open' ],
    rightMenuNavs: [
        {
            displayName: 'App Open Ads',
            hashName: '#app-open-ads',
            level: 1,
        },
        {
            displayName: 'Best Practices',
            hashName: '#best-practices',
            level: 2,
        },
        {
            displayName: 'Retention',
            hashName: '#retention',
            level: 2,
        },
        {
            displayName: 'Using an App Open Ad',
            hashName: '#using-an-app-open-ad',
            level: 1,
        },
        {
            displayName: 'Cold Starts and Loading Screens',
            hashName: '#cold-starts-and-loading-screens',
            level: 1,
        },
        {
            displayName: 'Examples',
            hashName: '#examples',
            level: 1,
        },
        {
            displayName: 'Supported Adapter Versions',
            hashName: '#supported-adapter-versions',
            level: 1,
        },
    ]
}

export const ANDROID_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/getting-started/terms-and-privacy-policy-flow' ],
    rightMenuNavs: [
        {
            displayName: 'SDK 12.0.0 Release',
            hashName: '#sdk-12.0.0-release',
            level: 1,
        },
        {
            displayName: 'Google UMP Automation',
            hashName: '#google-ump-automation',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP on AdMob Dashboard',
            hashName: '#enabling-google-ump-on-admob-dashboard',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP',
            hashName: '#enabling-google-ump',
            level: 1,
        },
        {
            displayName: 'Testing Google UMP Integration with the Mediation Debugger',
            hashName: '#testing-google-ump-integration-with-the-mediation-debugger',
            level: 1,
        },
    ]
}

export const FLUTTER_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/flutter/getting-started/terms-and-privacy-policy-flow' ],
    rightMenuNavs: [
        {
            displayName: 'SDK 12.0.0 Release',
            hashName: '#sdk-12.0.0-release',
            level: 1,
        },
        {
            displayName: 'Google UMP Automation',
            hashName: '#google-ump-automation',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP on AdMob Dashboard',
            hashName: '#enabling-google-ump-on-admob-dashboard',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP',
            hashName: '#enabling-google-ump',
            level: 1,
        },
        {
            displayName: 'Testing Google UMP Integration with the Mediation Debugger',
            hashName: '#testing-google-ump-integration-with-the-mediation-debugger',
            level: 1,
        },
    ]
}

export const IOS_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/getting-started/terms-and-privacy-policy-flow' ],
    rightMenuNavs: [
        {
            displayName: 'SDK 12.0.0 Release',
            hashName: '#sdk-12.0.0-release',
            level: 1,
        },
        {
            displayName: 'Google UMP Automation',
            hashName: '#google-ump-automation',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP on AdMob Dashboard',
            hashName: '#enabling-google-ump-on-admob-dashboard',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP',
            hashName: '#enabling-google-ump',
            level: 1,
        },
        {
            displayName: 'Testing Google UMP Integration with the Mediation Debugger',
            hashName: '#testing-google-ump-integration-with-the-mediation-debugger',
            level: 1,
        },
    ]
}

export const REACT_NATIVE_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/react-native/getting-started/terms-and-privacy-policy-flow' ],
    rightMenuNavs: [
        {
            displayName: 'SDK 12.0.0 Release',
            hashName: '#sdk-12.0.0-release',
            level: 1,
        },
        {
            displayName: 'Google UMP Automation',
            hashName: '#google-ump-automation',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP on AdMob Dashboard',
            hashName: '#enabling-google-ump-on-admob-dashboard',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP',
            hashName: '#enabling-google-ump',
            level: 1,
        },
        {
            displayName: 'Testing Google UMP Integration with the Mediation Debugger',
            hashName: '#testing-google-ump-integration-with-the-mediation-debugger',
            level: 1,
        },
    ]
}

export const INTERSTITIALS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/ad-formats/interstitials',
        '/documentation/mediation/cordova/ad-formats/interstitials',
        '/documentation/mediation/defold/ad-formats/interstitials',
        '/documentation/mediation/flutter/ad-formats/interstitials',
        '/documentation/mediation/godot/ad-formats/interstitials',
        '/documentation/mediation/ios/ad-formats/interstitials',
        '/documentation/mediation/react-native/ad-formats/interstitials',
        '/documentation/mediation/unity/ad-formats/interstitials',
        '/documentation/mediation/unreal/ad-formats/interstitials'
    ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Loading an Interstitial Ad",
      "hashName":"#loading-an-interstitial-ad",
      "level":"1"
   },
   {
      "displayName":"Showing an Interstitial Ad",
      "hashName":"#showing-an-interstitial-ad",
      "level":"1"
   }
]` )
}
export const ANDROID_INTERSTITIALS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/android/ad-formats/interstitials' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Interstitials",
      "hashName":"#interstitials",
      "level":"1"
   },
   {
      "displayName":"Loading an Interstitial Ad",
      "hashName":"#loading-an-interstitial-ad",
      "level":"2"
   },
   {
      "displayName":"Showing an Interstitial Ad",
      "hashName":"#showing-an-interstitial-ad",
      "level":"2"
   },
   {
      "displayName":"Lock Screen Ads",
      "hashName":"#lock-screen-ads",
      "level":"1"
   },
   {
      "displayName":"Loading a Lock Screen Ad",
      "hashName":"#loading-a-lock-screen-ad",
      "level":"2"
   },
   {
      "displayName":"Showing a Lock Screen Ad",
      "hashName":"#showing-a-lock-screen-ad",
      "level":"2"
   },
   {
      "displayName":"Mediated Network Support",
      "hashName":"#mediated-network-support",
      "level":"2"
   },
   {
      "displayName":"Adding Custom Support to Adapters",
      "hashName":"#adding-custom-support-to-adapters",
      "level":"2"
   }
]` )
}

export const SWIFTUI_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/ad-formats/swiftui' ],
    rightMenuNavs: JSON.parse( `
    [
        {
            "displayName":"Banners & MRECs",
            "hashName":"#banners-&-mrecs",
            "level":"1"
        },
        {
            "displayName":"Adaptive Banners",
            "hashName":"#adaptive-banners",
            "level":"2"
        },
        {
            "displayName": "Stopping and Starting Auto-Refresh",
            "hashName": "#stopping-and-starting-auto-refresh",
            "level":"2"
        }
    ]` )
}

export const IOS_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/ad-formats/banners' ],
    rightMenuNavs: JSON.parse( `
    [
        {
            "displayName":"Banners & MRECs",
            "hashName":"#banners-&-mrecs",
            "level":"1"
        },
        {
            "displayName":"Destroying Banners & MRECs",
            "hashName":"#destroying-banners-&-mrecs",
            "level":"2"
        },
        {
            "displayName":"Adaptive Banners",
            "hashName":"#adaptive-banners",
            "level":"1"
        },
        {
            "displayName": "Stopping and Starting Auto-Refresh",
            "hashName": "#stopping-and-starting-auto-refresh",
            "level": "1"
        }
    ]` )
}

export const IOS_NATIVE_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/ad-formats/native-templates' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Templates API",
            "hashName":"#templates-api",
            "level":"1"
        },
        {
            "displayName":"Loading a Native Ad",
            "hashName":"#loading-a-native-ad",
            "level":"1"
        },
        {
            "displayName":"Asset Sizes",
            "hashName":"#asset-sizes",
            "level":"1"
        },
        {
            "displayName":"How to Get the Media Content Aspect Ratio",
            "hashName":"#how-to-get-the-media-content-aspect-ratio",
            "level":"2"
        },
        {
            "displayName":"Supported Adapter Versions",
            "hashName":"#supported-adapter-versions",
            "level":"1"
        }
    ]` )
}
export const IOS_NATIVE_AD_PLACER_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/ad-formats/native-ad-placer' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Ad Placer API",
            "hashName":"#ad-placer-api",
            "level":"1"
        },
        {
            "displayName":"1. Set Up Native Ad Layout",
            "hashName":"#1.-set-up-native-ad-layout",
            "level":"1"
        },
        {
            "displayName":"2. Create Ad Placer Settings",
            "hashName":"#2.-create-ad-placer-settings",
            "level":"1"
        },
        {
            "displayName":"Configure Ad Positions",
            "hashName":"#configure-ad-positions",
            "level":"2"
        },
        {
            "displayName":"Additional Settings",
            "hashName":"#additional-settings",
            "level":"2"
        },
        {
            "displayName":"3. Set Up Ad Placer",
            "hashName":"#3.-set-up-ad-placer",
            "level":"1"
        },
        {
            "displayName":"Using MATableViewAdPlacer",
            "hashName":"#using-matableviewadplacer",
            "level":"2"
        },
        {
            "displayName":"Using MACollectionViewAdPlacer",
            "hashName":"#using-macollectionviewadplacer",
            "level":"2"
        },
        {
            "displayName":"4. Configure Ad Rendering Settings",
            "hashName":"#4.-configure-ad-rendering-settings",
            "level":"1"
        },
        {
            "displayName":"Templates",
            "hashName":"#templates",
            "level":"2"
        },
        {
            "displayName":"Manual",
            "hashName":"#manual",
            "level":"2"
        },
        {
            "displayName":"5. Optionally Receive Delegate Callbacks",
            "hashName":"#5.-optionally-receive-delegate-callbacks",
            "level":"1"
        }
    ]` )
}
export const IOS_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/ad-formats/native-manual' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Manual API",
            "hashName":"#manual-api",
            "level":"1"
        },
        {
            "displayName":"Bind UI Components",
            "hashName":"#bind-ui-components",
            "level":"2"
        },
        {
            "displayName":"Load the Native Ad",
            "hashName":"#load-the-native-ad",
            "level":"2"
        },
        {
            "displayName":"Destroy the Native Ad",
            "hashName":"#destroy-the-native-ad",
            "level":"2"
        },
        {
            "displayName":"Asset Sizes",
            "hashName":"#asset-sizes",
            "level":"1"
        },
        {
            "displayName":"How to Get the Media Content Aspect Ratio",
            "hashName":"#how-to-get-the-media-content-aspect-ratio",
            "level":"2"
        },
        {
            "displayName":"Supported Adapter Versions",
            "hashName":"#supported-adapter-versions-(native-ads,-manual)",
            "level":"1"
        },
        {
            "displayName":"Star Rating",
            "hashName":"#star-rating",
            "level":"1"
        }
    ]` )
}

export const IOS_SKADNETWORK_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [
        '/documentation/mediation/adobe-air/getting-started/skadnetwork-info',
        '/documentation/mediation/cordova/getting-started/skadnetwork-info',
        '/documentation/mediation/defold/getting-started/skadnetwork-info',
        '/documentation/mediation/flutter/getting-started/skadnetwork-info',
        '/documentation/mediation/godot/getting-started/skadnetwork-info',
        '/documentation/mediation/ios/getting-started/skadnetwork-info',
        '/documentation/mediation/react-native/getting-started/skadnetwork-info',
        '/documentation/mediation/unity/getting-started/skadnetwork-info',
        '/documentation/mediation/unreal/getting-started/skadnetwork-info'
    ],
    rightMenuNavs: JSON.parse( `[
       {
          "displayName":"Why Should I Implement SKAdNetwork?",
          "hashName":"#why-should-i-implement-skadnetwork?",
          "level":"1"
       },
       {
          "displayName":"How Do I Implement SKAdNetwork?",
          "hashName":"#how-do-i-implement-skadnetwork?",
          "level":"1"
       },
       {
          "displayName":"Info.plist Generator",
          "hashName":"#info.plist-generator",
          "level":"2"
       }
    ]` )
}
export const IOS_DATA_PASSING_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/getting-started/data-passing' ],
    rightMenuNavs: [
        {
            displayName: 'Data and Keyword Passing',
            hashName: '#data-and-keyword-passing',
            level: 1,
        },
        {
            displayName: 'Data Fields',
            hashName: '#data-fields',
            level: 2,
        },
        {
            displayName: 'Location Passing',
            hashName: '#location-passing',
            level: 1,
        },
        {
            displayName: 'Content URL Passing',
            hashName: '#content-url-passing',
            level: 1,
        },
        {
            displayName: 'Unified Identifiers',
            hashName: '#unified-identifiers',
            level: 1,
        }
    ]
}
export const IOS_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/getting-started/advanced-settings' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Ad Placements",
      "hashName":"#ad-placements",
      "level":"1"
   },
   {
      "displayName":"Banners / MRECs",
      "hashName":"#banners-/-mrecs",
      "level":"2"
   },
   {
      "displayName":"Interstitials",
      "hashName":"#interstitials",
      "level":"2"
   },
   {
      "displayName":"Rewarded Ads",
      "hashName":"#rewarded-ads",
      "level":"2"
   },
   {
      "displayName":"Native Ads",
      "hashName":"#native-ads",
      "level":"2"
   },
   {
      "displayName":"Mute Audio",
      "hashName":"#mute-audio",
      "level":"1"
   },
   {
      "displayName":"Enable Verbose Logging",
      "hashName":"#enable-verbose-logging",
      "level":"1"
   },
   {
      "displayName":"Programmatically",
      "hashName":"#programmatically",
      "level":"2"
   },
   {
      "displayName":"Info.plist",
      "hashName":"#info.plist",
      "level":"2"
   },
   {
      "displayName":"Creative ID and Network Name",
      "hashName":"#creative-id-and-network-name",
      "level":"1"
   },
   {
      "displayName":"DSP Name",
      "hashName":"#dsp-name",
      "level":"1"
   },
   {
      "displayName":"Impression-Level User Revenue API",
      "hashName":"#impression-level-user-revenue-api",
      "level":"1"
   },
   {
      "displayName":"Establishing Ad Request Callbacks",
      "hashName":"#establishing-ad-request-callbacks",
      "level":"1"
   },
   {
      "displayName":"Selective Init",
      "hashName":"#selective-init",
      "level":"1"
   },
   {
       "displayName":"Waterfall Information API",
       "hashName":"#waterfall-information-api",
       "level":"1"
   },
   {
       "displayName":"Customize Banner / MREC Ad Refresh",
       "hashName":"#customize-banner-/-mrec-ad-refresh",
       "level":"1"
   },
   {
       "displayName":"Audio Settings",
       "hashName":"#audio-settings",
       "level":"1"
   }
]` )
}
export const IOS_MEDIATION_ADAPTER_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ios/mediation-adapters' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"CocoaPods",
      "hashName":"#cocoapods",
      "level":"1"
   },
   {
      "displayName":"Install the New Pods",
      "hashName":"#install-the-new-pods",
      "level":"2"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const IOS_MANUAL_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/manual-integration-ios' ],
    rightMenuNavs: [
        {
            displayName: 'Getting Started',
            hashName: '#getting-started',
            level: 1,
        },
        {
            displayName: 'Download the Latest iOS SDK',
            hashName: '#',
            level: 1,
        },
        {
            displayName: 'Integrate the AppLovin SDK',
            hashName: '#integrate-the-applovin-sdk',
            level: 1,
        },
        {
            displayName: 'Enable Xcode Flags',
            hashName: '#enable-xcode-flags',
            level: 1,
        },
        {
            displayName: 'Add Frameworks',
            hashName: '#add-frameworks',
            level: 1,
        },
        {
            displayName: 'Enable Ad Review',
            hashName: '#enable-ad-review',
            level: 1,
        },
        {
            displayName: 'Add the SDK Key',
            hashName: '#add-the-sdk-key',
            level: 1,
        },
        {
            displayName: 'Initialize the SDK',
            hashName: '#initialize-the-sdk',
            level: 1,
        },
        {
            displayName: 'SKAdNetwork',
            hashName: '#skadnetwork',
            level: 1,
        },
        {
            displayName: 'Interstitial Ads',
            hashName: '#interstitial-ads',
            level: 1,
        },
        {
            displayName: 'Rewarded Ads',
            hashName: '#rewarded-ads',
            level: 1,
        },
        {
            displayName: 'Banners & MRECs',
            hashName: '#banners-&-mrecs',
            level: 1,
        },
        {
            displayName: 'Preparing Mediated Networks',
            hashName: '#preparing-mediated-networks',
            level: 1,
        },
        {
            displayName: 'Manual Download for MAX Mediation Networks',
            hashName: '#manual-download-for-max-mediation-networks',
            level: 1,
        },
    ]
}

export const CORDOVA_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/cordova/getting-started/integration' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Download the Latest Cordova Plugin",
      "hashName":"#download-the-latest-cordova-plugin",
      "level":"1"
   },
   {
      "displayName":"Enable Ad Review",
      "hashName":"#enable-ad-review",
      "level":"1"
   },
   {
      "displayName":"Android Instructions",
      "hashName":"#android-instructions",
      "level":"2"
   },
   {
      "displayName":"iOS Instructions",
      "hashName":"#ios-instructions",
      "level":"2"
   },
   {
      "displayName":"Initialize the SDK",
      "hashName":"#initialize-the-sdk",
      "level":"1"
   },
   {
      "displayName":"iOS 15 Global SKAdNetwork Reporting",
      "hashName":"#ios-15-global-skadnetwork-reporting",
      "level":"1"
   }
]` )
}


export const CORDOVA_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/cordova/ad-formats/banners' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Creating a Banner or MREC",
            "hashName":"#creating-a-banner-or-mrec",
            "level":"1"
        },
        {
            "displayName":"Displaying a Banner or MREC",
            "hashName":"#displaying-a-banner-or-mrec",
            "level":"1"
        },
        {
            "displayName":"Hiding a Banner or MREC",
            "hashName":"#hiding-a-banner-or-mrec",
            "level":"1"
        }
    ]` )
}

export const CORDOVA_DATA_PASSING_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/cordova/getting-started/data-passing' ],
    rightMenuNavs: [
        {
            displayName: 'Data and Keyword Passing',
            hashName: '#data-and-keyword-passing',
            level: 1,
        },
        {
            displayName: 'Data Fields',
            hashName: '#data-fields',
            level: 2,
        },
    ]
}

export const CORDOVA_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/cordova/getting-started/advanced-settings' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Ad Placements",
      "hashName":"#ad-placements",
      "level":"1"
   },
   {
      "displayName":"Banners / MRECs",
      "hashName":"#banners-/-mrecs",
      "level":"2"
   },
   {
      "displayName":"Interstitials",
      "hashName":"#interstitials",
      "level":"2"
   },
   {
      "displayName":"Rewarded Ads",
      "hashName":"#rewarded-ads",
      "level":"2"
   },
   {
      "displayName":"Mute Audio",
      "hashName":"#mute-audio",
      "level":"1"
   },
   {
      "displayName":"Enable Verbose Logging",
      "hashName":"#enable-verbose-logging",
      "level":"1"
   },
      {
      "displayName":"Segment Name",
      "hashName":"#segment-name",
      "level":"1"
   },
   {
      "displayName":"Creative ID and Network Name",
      "hashName":"#creative-id-and-network-name",
      "level":"1"
   }
]` )
}
export const CORDOVA_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/cordova/mediation-adapters/ios' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"CocoaPods",
      "hashName":"#cocoapods",
      "level":"1"
   },
   {
      "displayName":"Install the New Pods",
      "hashName":"#install-the-new-pods",
      "level":"2"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}
export const CORDOVA_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/cordova/mediation-adapters/android' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Gradle",
      "hashName":"#gradle",
      "level":"1"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const FLUTTER_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/flutter/getting-started/integration' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Download the Latest Plugin",
      "hashName":"#download-the-latest-plugin",
      "level":"1"
   },
   {
      "displayName":"Install the Plugin",
      "hashName":"#install-the-plugin",
      "level":"1"
   },
   {
      "displayName":"Import the Plugin",
      "hashName":"#import-the-plugin",
      "level":"1"
   },
   {
      "displayName":"Initialize the SDK",
      "hashName":"#initialize-the-sdk",
      "level":"1"
   },
   {
      "displayName":"iOS 15 Global SKAdNetwork Reporting",
      "hashName":"#ios-15-global-skadnetwork-reporting",
      "level":"1"
   }
]` )
}

export const GODOT_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/godot/getting-started/integration' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Download and Import the Latest Plugin",
      "hashName":"#download-and-import-the-latest-plugin",
      "level":"1"
   },
   {
      "displayName":"Initialize the SDK",
      "hashName":"#initialize-the-sdk",
      "level":"1"
   },
   {
      "displayName":"iOS 15 Global SKAdNetwork Reporting",
      "hashName":"#ios-15-global-skadnetwork-reporting",
      "level":"1"
   }
]` )
}

export const REACT_NATIVE_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/react-native/getting-started/integration' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Download the Latest Module",
      "hashName":"#download-the-latest-module",
      "level":"1"
   },
   {
      "displayName":"Enable Ad Review",
      "hashName":"#enable-ad-review",
      "level":"1"
   },
   {
      "displayName":"Android Instructions",
      "hashName":"#android-instructions",
      "level":"2"
   },
   {
      "displayName":"iOS Instructions",
      "hashName":"#ios-instructions",
      "level":"2"
   },
   {
      "displayName":"Initialize the SDK",
      "hashName":"#initialize-the-sdk",
      "level":"1"
   },
   {
      "displayName":"iOS 15 Global SKAdNetwork Reporting",
      "hashName":"#ios-15-global-skadnetwork-reporting",
      "level":"1"
   }
]` )
}

export const FLUTTER_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/flutter/ad-formats/banners' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Programmatic Method",
            "hashName":"#programmatic-method",
            "level":"1"
        },
        {
            "displayName":"Creating a Banner or MREC",
            "hashName":"#creating-a-banner-or-mrec",
            "level":"2"
        },
        {
            "displayName":"Displaying a Banner",
            "hashName":"#displaying-a-banner",
            "level":"2"
        },
        {
            "displayName":"Widget Method",
            "hashName":"#widget-method",
            "level":"1"
        },
        {
            "displayName":"Adaptive Banners",
            "hashName":"#adaptive-banners",
            "level":"1"
        },
        {
            "displayName":"Stopping and Starting Auto-Refresh",
            "hashName":"#stopping-and-starting-auto-refresh",
            "level":"1"
        }
    ]` )
}

export const GODOT_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/godot/ad-formats/banners' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Programmatic Method",
            "hashName":"#programmatic-method",
            "level":"1"
        },
        {
            "displayName":"Creating a Banner or MREC",
            "hashName":"#creating-a-banner-or-mrec",
            "level":"2"
        },
        {
            "displayName":"Displaying a Banner or MREC",
            "hashName":"#displaying-a-banner-or-mrec",
            "level":"2"
        },
        {
            "displayName":"Adaptive Banners",
            "hashName":"#adaptive-banners",
            "level":"1"
        },
        {
            "displayName":"Stopping and Starting Auto-Refresh",
            "hashName":"#stopping-and-starting-auto-refresh",
            "level":"1"
        }
    ]` )
}

export const REACT_NATIVE_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/react-native/ad-formats/banners' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Programmatic Method",
            "hashName":"#programmatic-method",
            "level":"1"
        },
        {
            "displayName":"Creating a Banner or MREC",
            "hashName":"#creating-a-banner-or-mrec",
            "level":"2"
        },
        {
            "displayName":"Displaying a Banner or MREC",
            "hashName":"#displaying-a-banner-or-mrec",
            "level":"2"
        },
        {
            "displayName":"Native UI Component Method",
            "hashName":"#native-ui-component-method",
            "level":"1"
        },
        {
            "displayName":"Adaptive Banners",
            "hashName":"#adaptive-banners",
            "level":"1"
        },
        {
            "displayName":"Stopping and Starting Auto-Refresh",
            "hashName":"#stopping-and-starting-auto-refresh",
            "level":"1"
        }
    ]` )
}

export const FLUTTER_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/flutter/ad-formats/native-manual' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Declare Flutter UI Components",
            "hashName":"#declare-flutter-ui-components",
            "level":"1"
        },
        {
            "displayName":"Ad Reloading",
            "hashName":"#ad-reloading",
            "level":"1"
        },
        {
            "displayName":"Asset Sizes",
            "hashName":"#asset-sizes",
            "level":"1"
        },
        {
            "displayName":"How to Get the Media Content Aspect Ratio",
            "hashName":"#how-to-get-the-media-content-aspect-ratio",
            "level":"2"
        },
        {
            "displayName":"Supported Adapter Versions",
            "hashName":"#supported-adapter-versions",
            "level":"2"
        },
        {
            "displayName":"Star Rating",
            "hashName":"#star-rating",
            "level":"1"
        }
    ]` )
}

export const GODOT_NATIVE_MANUAL_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/godot/ad-formats/native-manual' ],
    rightMenuNavs: JSON.parse( `[
        {
            "displayName":"Declare Godot UI Components",
            "hashName":"#declare-godot-ui-components",
            "level":"1"
        },
        {
            "displayName":"Ad Reloading",
            "hashName":"#ad-reloading",
            "level":"1"
        },
        {
            "displayName":"Asset Sizes",
            "hashName":"#asset-sizes",
            "level":"1"
        },
        {
            "displayName":"How to Get the Media Content Aspect Ratio",
            "hashName":"#how-to-get-the-media-content-aspect-ratio",
            "level":"2"
        },
        {
            "displayName":"Supported Adapter Versions",
            "hashName":"#supported-adapter-versions",
            "level":"2"
        },
        {
            "displayName":"Star Rating",
            "hashName":"#star-rating",
            "level":"1"
        }
    ]` )
}

export const FLUTTER_DATA_PASSING_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/flutter/getting-started/data-passing' ],
    rightMenuNavs: [
        {
            displayName: 'Data and Keyword Passing',
            hashName: '#data-and-keyword-passing',
            level: 1,
        },
        {
            displayName: 'Data Fields',
            hashName: '#data-fields',
            level: 2,
        },
        {
            displayName: 'Location Passing',
            hashName: '#location-passing',
            level: 1,
        },
        {
            displayName: 'Content URL Passing',
            hashName: '#content-url-passing',
            level: 1,
        },
    ]
}

export const GODOT_DATA_PASSING_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/godot/getting-started/data-passing' ],
    rightMenuNavs: [
        {
            displayName: 'Data and Keyword Passing',
            hashName: '#data-and-keyword-passing',
            level: 1,
        },
        {
            displayName: 'Data Fields',
            hashName: '#data-fields',
            level: 2,
        },
        {
            displayName: 'Location Passing',
            hashName: '#location-passing',
            level: 1,
        },
        {
            displayName: 'Content URL Passing',
            hashName: '#content-url-passing',
            level: 1,
        },
    ]
}

export const REACT_NATIVE_DATA_PASSING_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/react-native/getting-started/data-passing' ],
    rightMenuNavs: [
        {
            displayName: 'Data and Keyword Passing',
            hashName: '#data-and-keyword-passing',
            level: 1,
        },
        {
            displayName: 'Data Fields',
            hashName: '#data-fields',
            level: 2,
        },
        {
            displayName: 'Location Passing',
            hashName: '#location-passing',
            level: 1,
        },
        {
            displayName: 'Content URL Passing',
            hashName: '#content-url-passing',
            level: 1,
        },
    ]
}

export const FLUTTER_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/flutter/getting-started/advanced-settings' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Ad Placements",
      "hashName":"#ad-placements",
      "level":"1"
   },
   {
      "displayName":"Banners / MRECs (Programmatic Method)",
      "hashName":"#banners-/-mrecs-(programmatic-method)",
      "level":"3"
   },
   {
      "displayName":"Interstitials",
      "hashName":"#interstitials",
      "level":"2"
   },
   {
      "displayName":"Rewarded Ads",
      "hashName":"#rewarded-ads",
      "level":"2"
   },
   {
      "displayName":"Mute Audio",
      "hashName":"#mute-audio",
      "level":"1"
   },
   {
      "displayName":"Enable Verbose Logging",
      "hashName":"#enable-verbose-logging",
      "level":"1"
   },
   {
      "displayName":"Segment Name",
      "hashName":"#segment-name",
      "level":"1"
   },
   {
      "displayName":"Creative ID and Network Name",
      "hashName":"#creative-id-and-network-name",
      "level":"1"
   },
   {
      "displayName":"DSP Name",
      "hashName":"#dsp-name",
      "level":"1"
   },
   {
      "displayName":"Impression-Level User Revenue API",
      "hashName":"#impression-level-user-revenue-api",
      "level":"1"
   },
   {
      "displayName": "Selective Init",
      "hashName": "#selective-init",
      "level": "1"
   },
   {
      "displayName":"Waterfall Information API",
      "hashName":"#waterfall-information-api",
      "level":"1"
   }
]` )
}

export const GODOT_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/godot/getting-started/advanced-settings' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Ad Placements",
      "hashName":"#ad-placements",
      "level":"1"
   },
   {
      "displayName":"Mute Audio",
      "hashName":"#mute-audio",
      "level":"1"
   },
   {
      "displayName":"Enable Verbose Logging",
      "hashName":"#enable-verbose-logging",
      "level":"1"
   },
   {
      "displayName":"Segment Name",
      "hashName":"#segment-name",
      "level":"1"
   },
   {
      "displayName":"Creative ID and Network Name",
      "hashName":"#creative-id-and-network-name",
      "level":"1"
   },
   {
      "displayName":"DSP Name",
      "hashName":"#dsp-name",
      "level":"1"
   },
   {
      "displayName":"Impression-Level User Revenue API",
      "hashName":"#impression-level-user-revenue-api",
      "level":"1"
   },
   {
      "displayName":"Waterfall Information API",
      "hashName":"#waterfall-information-api",
      "level":"1"
   }
]` )
}

export const REACT_NATIVE_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/react-native/getting-started/advanced-settings' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Ad Placements",
      "hashName":"#ad-placements",
      "level":"1"
   },
   {
      "displayName":"Banners / MRECs (Programmatic Method)",
      "hashName":"#banners-/-mrecs-(programmatic-method)",
      "level":"2"
   },
   {
      "displayName":"Banners / MRECs (Native UI Component Method)",
      "hashName":"#banners-/-mrecs-(native-ui-component-method)",
      "level":"2"
   },
   {
      "displayName":"Interstitials",
      "hashName":"#interstitials",
      "level":"3"
   },
   {
      "displayName":"Rewarded Ads",
      "hashName":"#rewarded-ads",
      "level":"3"
   },
   {
      "displayName":"Mute Audio",
      "hashName":"#mute-audio",
      "level":"1"
   },
   {
      "displayName":"Enable Verbose Logging",
      "hashName":"#enable-verbose-logging",
      "level":"1"
   },
   {
      "displayName":"Creative ID and Network Name",
      "hashName":"#creative-id-and-network-name",
      "level":"1"
   },
   {
      "displayName":"DSP Name",
      "hashName":"#dsp-name",
      "level":"1"
   },
   {
      "displayName":"Impression-Level User Revenue API",
      "hashName":"#impression-level-user-revenue-api",
      "level":"1"
   },
   {
      "displayName": "Selective Init",
      "hashName": "#selective-init",
      "level": "1"
   },
   {
      "displayName":"Waterfall Information API",
      "hashName":"#waterfall-information-api",
      "level":"1"
   }
]` )
}

export const FLUTTER_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/flutter/mediation-adapters/ios' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"CocoaPods",
      "hashName":"#cocoapods",
      "level":"1"
   },
   {
      "displayName":"Install the New Pods",
      "hashName":"#install-the-new-pods",
      "level":"2"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const GODOT_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/godot/mediation-adapters/ios' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"CocoaPods",
      "hashName":"#cocoapods",
      "level":"1"
   },
   {
      "displayName":"Install the New Pods",
      "hashName":"#install-the-new-pods",
      "level":"2"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const REACT_NATIVE_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/react-native/mediation-adapters/ios' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"CocoaPods",
      "hashName":"#cocoapods",
      "level":"1"
   },
   {
      "displayName":"Install the New Pods",
      "hashName":"#install-the-new-pods",
      "level":"2"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const FLUTTER_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/flutter/mediation-adapters/android' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Gradle",
      "hashName":"#gradle",
      "level":"1"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const GODOT_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/godot/mediation-adapters/android' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Gradle",
      "hashName":"#gradle",
      "level":"1"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const REACT_NATIVE_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/react-native/mediation-adapters/android' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Gradle",
      "hashName":"#gradle",
      "level":"1"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const DEFOLD_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/defold/getting-started/integration' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Download and Import the Latest Defold Plugin",
      "hashName":"#download-and-import-the-latest-defold-plugin",
      "level":"1"
   },
   {
      "displayName":"Initialize the SDK",
      "hashName":"#initialize-the-sdk",
      "level":"1"
   },
   {
      "displayName":"iOS 14 Support",
      "hashName":"#ios-14-support",
      "level":"1"
   },
   {
      "displayName":"SKAdNetwork",
      "hashName":"#skadnetwork",
      "level":"2"
   },
   {
      "displayName":"Consent and Data APIs",
      "hashName":"#consent-and-data-apis",
      "level":"2"
   },
   {
      "displayName":"iOS 15 Global SKAdNetwork Reporting",
      "hashName":"#ios-15-global-skadnetwork-reporting",
      "level":"1"
   }
]` )
}

export const UNREAL_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unreal/getting-started/integration' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Download the Latest Unreal Plugin",
      "hashName":"#download-the-latest-unreal-plugin",
      "level":"1"
   },
      {
      "displayName":"Import the Plugin into Unreal",
      "hashName":"#import-the-plugin-into-unreal",
      "level":"1"
   },
   {
      "displayName":"Requirements",
      "hashName":"#requirements",
      "level":"1"
   },
   {
      "displayName":"Initialize the SDK",
      "hashName":"#initialize-the-sdk",
      "level":"1"
   },
   {
      "displayName":"iOS 14 Support",
      "hashName":"#ios-14-support",
      "level":"1"
   },
   {
      "displayName":"SKAdNetwork",
      "hashName":"#skadnetwork",
      "level":"2"
   },
   {
      "displayName":"Consent and Data APIs",
      "hashName":"#consent-and-data-apis",
      "level":"2"
   },
   {
      "displayName":"iOS 15 Global SKAdNetwork Reporting",
      "hashName":"#ios-15-global-skadnetwork-reporting",
      "level":"1"
   }
]` )
}

export const UNITY_INTEGRATION_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unity/getting-started/integration' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Download the Latest Unity Plugin",
      "hashName":"#download-the-latest-unity-plugin",
      "level":"1"
   },
   {
      "displayName":"Import the Plugin into Unity",
      "hashName":"#import-the-plugin-into-unity",
      "level":"1"
   },
   {
      "displayName":"Requirements",
      "hashName":"#requirements",
      "level":"1"
   },
   {
      "displayName":"Enable Ad Review",
      "hashName":"#enable-ad-review",
      "level":"1"
   },
   {
      "displayName":"Initialize the SDK",
      "hashName":"#initialize-the-sdk",
      "level":"1"
   },
   {
      "displayName":"iOS 14 Support",
      "hashName":"#ios-14-support",
      "level":"1"
   },
   {
      "displayName":"SKAdNetwork",
      "hashName":"#skadnetwork",
      "level":"2"
   },
   {
      "displayName":"MAX Terms and Privacy Policy Flow",
      "hashName":"#max-terms-and-privacy-policy-flow",
      "level":"2"
   },
   {
      "displayName":"Consent and Data APIs",
      "hashName":"#consent-and-data-apis",
      "level":"2"
   },
   {
      "displayName":"iOS 15 Global SKAdNetwork Reporting",
      "hashName":"#ios-15-global-skadnetwork-reporting",
      "level":"1"
   }
]` )
}

export const FLUTTER_APP_OPEN_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/flutter/ad-formats/app-open' ],
    rightMenuNavs: [
        {
            displayName: 'App Open Ads',
            hashName: '#app-open-ads',
            level: 1,
        },
        {
            displayName: 'Best Practices',
            hashName: '#best-practices',
            level: 2,
        },
        {
            displayName: 'Retention',
            hashName: '#retention',
            level: 2,
        },
        {
            displayName: 'Using an App Open Ad',
            hashName: '#using-an-app-open-ad',
            level: 1,
        },
        {
            displayName: 'Listen for App Foregrounding Events',
            hashName: '#listen-for-app-foregrounding-events',
            level: 1,
        },
        {
            displayName: 'Cold Starts and Loading Screens',
            hashName: '#cold-starts-and-loading-screens',
            level: 1,
        },
        {
            displayName: 'Example',
            hashName: '#example',
            level: 1,
        },
        {
            displayName: 'Supported Adapter Versions',
            hashName: '#supported-adapter-versions',
            level: 1,
        },
    ]
}

export const GODOT_APP_OPEN_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/godot/ad-formats/app-open' ],
    rightMenuNavs: [
        {
            displayName: 'App Open Ads',
            hashName: '#app-open-ads',
            level: 1,
        },
        {
            displayName: 'Best Practices',
            hashName: '#best-practices',
            level: 2,
        },
        {
            displayName: 'Retention',
            hashName: '#retention',
            level: 2,
        },
        {
            displayName: 'Using an App Open Ad',
            hashName: '#using-an-app-open-ad',
            level: 1,
        },
        {
            displayName: 'Listen for App Foregrounding Events',
            hashName: '#listen-for-app-foregrounding-events',
            level: 1,
        },
        {
            displayName: 'Cold Starts and Loading Screens',
            hashName: '#cold-starts-and-loading-screens',
            level: 1,
        },
        {
            displayName: 'Example',
            hashName: '#example',
            level: 1,
        },
        {
            displayName: 'Supported Adapter Versions',
            hashName: '#supported-adapter-versions',
            level: 1,
        },
    ]
}

export const REACT_NATIVE_APP_OPEN_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/react-native/ad-formats/app-open' ],
    rightMenuNavs: [
        {
            displayName: 'App Open Ads',
            hashName: '#app-open-ads',
            level: 1,
        },
        {
            displayName: 'Best Practices',
            hashName: '#best-practices',
            level: 2,
        },
        {
            displayName: 'Retention',
            hashName: '#retention',
            level: 2,
        },
        {
            displayName: 'Using an App Open Ad',
            hashName: '#using-an-app-open-ad',
            level: 1,
        },
        {
            displayName: 'Cold Starts and Loading Screens',
            hashName: '#cold-starts-and-loading-screens',
            level: 1,
        },
        {
            displayName: 'Example',
            hashName: '#example',
            level: 1,
        },
        {
            displayName: 'Supported Adapter Versions',
            hashName: '#supported-adapter-versions',
            level: 1,
        },
    ]
}

export const UNITY_APP_OPEN_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unity/ad-formats/app-open' ],
    rightMenuNavs: [
        {
            displayName: 'App Open Ads',
            hashName: '#app-open-ads',
            level: 1,
        },
        {
            displayName: 'Best Practices',
            hashName: '#best-practices',
            level: 2,
        },
        {
            displayName: 'Retention',
            hashName: '#retention',
            level: 2,
        },
        {
            displayName: 'Using an App Open Ad',
            hashName: '#using-an-app-open-ad',
            level: 1,
        },
        {
            displayName: 'Listen for App Foregrounding Events',
            hashName: '#listen-for-app-foregrounding-events',
            level: 1,
        },
        {
            displayName: 'Cold Starts and Loading Screens',
            hashName: '#cold-starts-and-loading-screens',
            level: 1,
        },
        {
            displayName: 'Example',
            hashName: '#example',
            level: 1,
        },
        {
            displayName: 'Supported Adapter Versions',
            hashName: '#supported-adapter-versions',
            level: 1,
        },
    ]
}

export const UNITY_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unity/getting-started/terms-and-privacy-policy-flow' ],
    rightMenuNavs: [
        {
            displayName: 'SDK 12.0.0 Release',
            hashName: '#sdk-12.0.0-release',
            level: 1,
        },
        {
            displayName: 'Google UMP Automation',
            hashName: '#google-ump-automation',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP on AdMob Dashboard',
            hashName: '#enabling-google-ump-on-admob-dashboard',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP',
            hashName: '#enabling-google-ump',
            level: 1,
        },
        {
            displayName: 'Testing Google UMP Integration with the Mediation Debugger',
            hashName: '#testing-google-ump-integration-with-the-mediation-debugger',
            level: 1,
        },
    ]
}

export const DEFOLD_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/defold/getting-started/terms-and-privacy-policy-flow' ],
    rightMenuNavs: [
        {
            displayName: 'SDK 12.0.0 Release',
            hashName: '#sdk-12.0.0-release',
            level: 1,
        },
        {
            displayName: 'Google UMP Automation',
            hashName: '#google-ump-automation',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP on AdMob Dashboard',
            hashName: '#enabling-google-ump-on-admob-dashboard',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP',
            hashName: '#enabling-google-ump',
            level: 1,
        },
        {
            displayName: 'Testing Google UMP Integration with the Mediation Debugger',
            hashName: '#testing-google-ump-integration-with-the-mediation-debugger',
            level: 1,
        },
    ]
}

export const UNREAL_CONSENT_FLOW_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unreal/getting-started/terms-and-privacy-policy-flow' ],
    rightMenuNavs: [
        {
            displayName: 'SDK 12.0.0 Release',
            hashName: '#sdk-12.0.0-release',
            level: 1,
        },
        {
            displayName: 'Google UMP Automation',
            hashName: '#google-ump-automation',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP on AdMob Dashboard',
            hashName: '#enabling-google-ump-on-admob-dashboard',
            level: 1,
        },
        {
            displayName: 'Enabling Google UMP',
            hashName: '#enabling-google-ump',
            level: 1,
        },
        {
            displayName: 'Testing Google UMP Integration with the Mediation Debugger',
            hashName: '#testing-google-ump-integration-with-the-mediation-debugger',
            level: 1,
        },
    ]
}

export const DEFOLD_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/defold/ad-formats/banners' ],
    rightMenuNavs: JSON.parse( `[
       {
          "displayName":"Loading a Banner or MREC",
          "hashName":"#loading-a-banner-or-mrec",
          "level":"1"
       },
       {
          "displayName":"Showing a Banner or MREC",
          "hashName":"#showing-a-banner-or-mrec",
          "level":"1"
       },
       {
          "displayName":"Hiding a Banner or MREC",
          "hashName":"#hiding-a-banner-or-mrec",
          "level":"1"
       },
       {
          "displayName":"Stopping and Starting Auto-Refresh",
          "hashName":"#stopping-and-starting-auto-refresh",
          "level":"1"
       }
    ]` )
}

export const UNREAL_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unreal/ad-formats/banners' ],
    rightMenuNavs: JSON.parse( `[
       {
          "displayName":"Loading a Banner or MREC",
          "hashName":"#loading-a-banner-or-mrec",
          "level":"1"
       },
       {
          "displayName":"Showing a Banner or MREC",
          "hashName":"#showing-a-banner-or-mrec",
          "level":"1"
       },
       {
          "displayName":"Hiding a Banner or MREC",
          "hashName":"#hiding-a-banner-or-mrec",
          "level":"1"
       }
    ]` )
}

export const UNITY_BANNERS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unity/ad-formats/banners' ],
    rightMenuNavs: JSON.parse( `[
       {
         "displayName":"Banners & MRECs",
         "hashName":"#banners-&-mrecs",
         "level":"1"
      },
      {
         "displayName":"Loading a Banner or MREC",
         "hashName":"#loading-a-banner-or-mrec",
         "level":"2"
      },
      {
         "displayName":"Showing a Banner or MREC",
         "hashName":"#showing-a-banner-or-mrec",
         "level":"2"
      },
      {
         "displayName":"Hiding a Banner or MREC",
         "hashName":"#hiding-a-banner-or-mrec",
         "level":"2"
      },
      {
         "displayName":"Destroying Banners or MRECs",
         "hashName":"#destroying-banners-or-mrecs",
         "level":"2"
      },
      {
         "displayName":"Getting Banner Position",
         "hashName":"#getting-banner-position",
         "level":"2"
      },
      {
         "displayName":"Setting Banner Width",
         "hashName":"#setting-banner-width",
         "level":"2"
      },
      {
         "displayName":"Adaptive Banners",
         "hashName":"#adaptive-banners",
         "level":"1"
      },
      {
         "displayName":"Stopping and Starting Auto-Refresh",
         "hashName":"#stopping-and-starting-auto-refresh",
         "level":"1"
      }
   ]` )
}

export const DEFOLD_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/defold/getting-started/advanced-settings' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Ad Placements",
      "hashName":"#ad-placements",
      "level":"1"
   },
   {
      "displayName":"Banners & MRECs",
      "hashName":"#banners-&-mrecs",
      "level":"2"
   },
   {
      "displayName":"Interstitials",
      "hashName":"#interstitials",
      "level":"2"
   },
   {
      "displayName":"Rewarded Ads",
      "hashName":"#rewarded-ads",
      "level":"2"
   },
   {
      "displayName":"Mute Audio",
      "hashName":"#mute-audio",
      "level":"1"
   },
   {
      "displayName":"Enable Verbose Logging",
      "hashName":"#enable-verbose-logging",
      "level":"1"
   },
   {
      "displayName":"Creative ID and Network Name",
      "hashName":"#creative-id-and-network-name",
      "level":"1"
   }
]` )
}

export const UNREAL_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unreal/getting-started/advanced-settings' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Ad Placements",
      "hashName":"#ad-placements",
      "level":"1"
   },
   {
      "displayName":"Banners & MRECs",
      "hashName":"#banners-&-mrecs",
      "level":"2"
   },
   {
      "displayName":"Interstitials",
      "hashName":"#interstitials",
      "level":"2"
   },
   {
      "displayName":"Rewarded Ads",
      "hashName":"#rewarded-ads",
      "level":"2"
   },
   {
      "displayName":"Mute Audio",
      "hashName":"#mute-audio",
      "level":"1"
   },
   {
      "displayName":"Enable Verbose Logging",
      "hashName":"#enable-verbose-logging",
      "level":"1"
   },
   {
      "displayName":"Creative ID and Network Name",
      "hashName":"#creative-id-and-network-name",
      "level":"1"
   }
]` )
}
export const UNITY_DATA_PASSING_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unity/getting-started/data-passing' ],
    rightMenuNavs: [
        {
            displayName: 'Data and Keyword Passing',
            hashName: '#data-and-keyword-passing',
            level: 1,
        },
        {
            displayName: 'Data Fields',
            hashName: '#data-fields',
            level: 2,
        },
        {
            displayName: 'Location Passing',
            hashName: '#location-passing',
            level: 1,
        },
        {
            displayName: 'Content URL Passing',
            hashName: '#content-url-passing',
            level: 1,
        },
        {
            displayName: 'Unified Identifiers',
            hashName: '#unified-identifiers',
            level: 1,
        }
    ]
}
export const UNITY_ADVANCED_SETTINGS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unity/getting-started/advanced-settings' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Ad Placements",
      "hashName":"#ad-placements",
      "level":"1"
   },
   {
      "displayName":"Banners / MRECs",
      "hashName":"#banners-/-mrecs",
      "level":"2"
   },
   {
      "displayName":"Interstitials",
      "hashName":"#interstitials",
      "level":"2"
   },
   {
      "displayName":"Rewarded Ads",
      "hashName":"#rewarded-ads",
      "level":"2"
   },
   {
      "displayName":"Mute Audio",
      "hashName":"#mute-audio",
      "level":"1"
   },
   {
      "displayName":"Segment Name",
      "hashName":"#segment-name",
      "level":"1"
   },
   {
      "displayName":"Enable Verbose Logging",
      "hashName":"#enable-verbose-logging",
      "level":"1"
   },
   {
      "displayName":"Creative ID and Network Name",
      "hashName":"#creative-id-and-network-name",
      "level":"1"
   },
   {
      "displayName":"DSP Name",
      "hashName":"#dsp-name",
      "level":"1"
   },
   {
      "displayName":"Impression-Level User Revenue API",
      "hashName":"#impression-level-user-revenue-api",
      "level":"1"
   },
   {
      "displayName":"Selective Init",
      "hashName":"#selective-init",
      "level":"1"
   },
   {
       "displayName":"Waterfall Information API",
       "hashName":"#waterfall-information-api",
       "level":"1"
   },
   {
       "displayName":"Customize Banner / MREC Ad Refresh",
       "hashName":"#customize-banner-/-mrec-ad-refresh",
       "level":"1"
   }
]` )
}

export const DEFOLD_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/defold/mediation-adapters/android' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Gradle",
      "hashName":"#gradle",
      "level":"1"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const UNREAL_MEDIATION_ADAPTER_ANDROID_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unreal/mediation-adapters/android' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Android Instructions",
      "hashName":"#android-instructions",
      "level":"1"
   },
   {
      "displayName":"Gradle",
      "hashName":"#gradle",
      "level":"1"
   }
]` )
}

export const DEFOLD_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/defold/mediation-adapters/ios' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Cocoapods",
      "hashName":"#cocoapods",
      "level":"1"
   },
   {
      "displayName":"Adapter Network Information",
      "hashName":"#adapter-network-information",
      "level":"1"
   }
]` )
}

export const UNREAL_MEDIATION_ADAPTER_IOS_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unreal/mediation-adapters/ios' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"iOS Instructions",
      "hashName":"#ios-instructions",
      "level":"1"
   },
   {
      "displayName":"Requirements",
      "hashName":"#requirmentspods",
      "level":"2"
   },
   {
      "displayName":"Instructions",
      "hashName":"#instructions",
      "level":"2"
   }
]` )
}

export const UNITY_MEDIATION_ADAPTER_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unity/mediation-adapters' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"iOS-Specific Instructions",
      "hashName":"#ios-specific-instructions",
      "level":"1"
   },
   {
      "displayName":"Android-Specific Instructions",
      "hashName":"#android-specific-instructions",
      "level":"1"
   },
   {
      "displayName":"Integration Manager",
      "hashName":"#integration-manager",
      "level":"1"
   },
   {
      "displayName":"Manual Download",
      "hashName":"#manual-download",
      "level":"1"
   }
]` )
}

export const UNITY_AMAZON_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/unity/mediation-adapters/amazon' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Add the Amazon Publisher Services Adapter Plugin",
      "hashName":"#add-the-amazon-publisher-services-adapter-plugin",
      "level":"1"
   },
   {
      "displayName":"Add Permissions to the Android Manifest",
      "hashName":"#add-permissions-to-the-android-manifest",
      "level":"1"
   },
   {
      "displayName":"Initialize the Amazon SDK",
      "hashName":"#initialize-the-amazon-sdk",
      "level":"1"
   },
   {
      "displayName":"Load a Banner or MREC Ad from Amazon’s SDK",
      "hashName":"#load-a-banner-or-mrec-ad-from-amazon’s-sdk",
      "level":"1"
   },
   {
      "displayName":"Load an Interstitial Ad from Amazon’s SDK",
      "hashName":"#load-an-interstitial-ad-from-amazon’s-sdk",
      "level":"1"
   },
   {
      "displayName":"Load a Rewarded Video Ad from Amazon’s SDK",
      "hashName":"#load-a-rewarded-video-ad-from-amazon’s-sdk",
      "level":"1"
   },
   {
      "displayName":"Testing Amazon Publisher Services",
      "hashName":"#testing-amazon-publisher-services",
      "level":"1"
   }
]` )
}

export const REPORTING_APIS_AD_REVENUE_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/reporting-api/max-ad-revenue' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Request Format",
      "hashName":"#request-format",
      "level":"1"
   },
   {
      "displayName":"Target URL",
      "hashName":"#target-url",
      "level":"2"
   },
   {
      "displayName":"Parameters",
      "hashName":"#parameters",
      "level":"2"
   },
   {
      "displayName":"Columns",
      "hashName":"#columns",
      "level":"2"
   },
   {
      "displayName":"Response Format",
      "hashName":"#response-format",
      "level":"1"
   },
   {
      "displayName":"CSV",
      "hashName":"#csv",
      "level":"2"
   },
   {
      "displayName":"JSON",
      "hashName":"#json",
      "level":"2"
   }
]` )
}
export const REPORTING_APIS_USER_AD_REVENUE_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/reporting-api/user-ad-revenue' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Request Format",
      "hashName":"#request-format",
      "level":"1"
   },
   {
      "displayName":"Target URL",
      "hashName":"#target-url",
      "level":"2"
   },
   {
      "displayName":"Request Parameters",
      "hashName":"#request-parameters",
      "level":"2"
   },
   {
      "displayName":"Response Format",
      "hashName":"#response-format",
      "level":"1"
   },
   {
      "displayName":"Response Body",
      "hashName":"#response-body",
      "level":"2"
   },
   {
      "displayName":"Response Parameters",
      "hashName":"#response-parameters",
      "level":"2"
   },
   {
      "displayName":"User-Level Revenue Data CSV Format",
      "hashName":"#user-level-revenue-data-csv-format",
      "level":"1"
   },
   {
      "displayName":"User-level Revenue Data CSV Example — Aggregated",
      "hashName":"#user-level-revenue-data-csv-example-%E2%80%94-aggregated",
      "level":"2"
   },
   {
      "displayName":"User-level Revenue Data CSV Example — Non Aggregated (Impression Level)",
      "hashName":"#user-level-revenue-data-csv-example-%E2%80%94-non-aggregated-(impression-level)",
      "level":"2"
   },
   {
      "displayName":"Fields",
      "hashName":"#fields",
      "level":"2"
   },
   {
      "displayName":"Setting an Ad Placement Name",
      "hashName":"#setting-an-ad-placement-name",
      "level":"1"
   },
   {
      "displayName":"Setting an Internal User ID",
      "hashName":"#setting-an-internal-user-id",
      "level":"1"
   },
   {
      "displayName":"Custom Data",
      "hashName":"#custom-data",
      "level":"1"
   }
]` )
}
export const REPORTING_APIS_COHORT_COMPONENT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/reporting-api/max-cohort' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Request Format",
      "hashName":"#request-format",
      "level":"1"
   },
   {
      "displayName":"Target URLs",
      "hashName":"#target-urls",
      "level":"2"
   },
   {
      "displayName":"Parameters",
      "hashName":"#parameters",
      "level":"2"
   },
   {
      "displayName":"/maxCohort Columns",
      "hashName":"#/maxcohort-columns",
      "level":"2"
   },
   {
      "displayName":"/maxCohort/imp Columns",
      "hashName":"#/maxcohort/imp-columns",
      "level":"2"
   },
   {
      "displayName":"/maxCohort/session Columns",
      "hashName":"#/maxcohort/session-columns",
      "level":"2"
   },
   {
      "displayName":"Response Format",
      "hashName":"#response-format",
      "level":"1"
   },
   {
      "displayName":"CSV",
      "hashName":"#csv",
      "level":"2"
   },
   {
      "displayName":"JSON",
      "hashName":"#json",
      "level":"2"
   }
]` )
}

export const ADVANCED_FEATURES_AB_TESTING_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/features/ab-test' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Creating an A/B Test",
      "hashName":"#creating-an-a/b-test",
      "level":"1"
   },
   {
      "displayName":"Monitoring Results",
      "hashName":"#monitoring-results",
      "level":"1"
   },
   {
      "displayName":"Understanding Results",
      "hashName":"#understanding-results",
      "level":"1"
   }
]` )
}
export const ADVANCED_FEATURES_WATERFALL_SEGMENTATION_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/features/waterfall-segmentation' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Creating a New Waterfall",
      "hashName":"#creating-a-new-waterfall",
      "level":"1"
   },
   {
      "displayName":"Cloning an Existing Waterfall",
      "hashName":"#cloning-an-existing-waterfall",
      "level":"1"
   },
   {
      "displayName":"Monitoring Results",
      "hashName":"#monitoring-results",
      "level":"1"
   }
]` )
}

export const ADVANCED_FEATURES_DIRECT_SOLD_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/features/direct-sold' ],
    rightMenuNavs: [
        {
            displayName: 'Creating a Direct Sold Campaign',
            hashName: '#creating-a-direct-sold-campaign',
            level: 1,
        },
        {
            displayName: 'Basic Info',
            hashName: '#basic-info',
            level: 2,
        },
        {
            displayName: 'Targeting',
            hashName: '#targeting',
            level: 2,
        },
        {
            displayName: 'Bids, Day Parting, Daily Budgets, and Dates',
            hashName: '#bids,-day-parting,-daily-budgets,-and-dates',
            level: 2,
        },
        {
            displayName: 'Adding Creative Tags',
            hashName: '#adding-creative-tags',
            level: 1,
        },
        {
            displayName: 'Additional Use Cases',
            hashName: '#additional-use-cases',
            level: 1,
        },
        {
            displayName: 'Monitoring Campaign Results',
            hashName: '#monitoring-campaign-results',
            level: 1,
        },
        {
            displayName: 'Viewability',
            hashName: '#viewability',
            level: 1,
        },
        {
            displayName: 'Setting Up Direct Sold Viewability Campaigns',
            hashName: '#setting-up-direct-sold-viewability-campaigns',
            level: 2,
        },
        {
            displayName: 'Testing Your Viewability Tags',
            hashName: '#testing-your-viewability-tags',
            level: 2,
        },
        {
            displayName: 'Best Practices',
            hashName: '#best-practices',
            level: 2,
        },
        {
            displayName: 'Reporting',
            hashName: '#reporting',
            level: 2,
        },
    ]
}

export const ADVANCED_FEATURES_AD_UNIT_AUTOMATION_API_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/features/ad-unit-automation-api' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"The /ad_unit Endpoint",
      "hashName":"#the-/ad_unit-endpoint",
      "level":"1"
   },
   {
      "displayName":"The /ad_units Endpoint",
      "hashName":"#the-/ad_units-endpoint",
      "level":"1"
   },
   {
      "displayName":"The /ad_unit_experiment Endpoint",
      "hashName":"#the-/ad_unit_experiment/[ad_unit_id]-endpoint",
      "level":"1"
   },
   {
      "displayName":"The /test_device Endpoint",
      "hashName":"#the-/test_device-endpoint",
      "level":"1"
   },
   {
      "displayName":"The /test_devices Endpoint",
      "hashName":"#the-/test_devices-endpoint",
      "level":"1"
   },
   {
      "displayName":"Multiple Waterfalls",
      "hashName":"#multiple-waterfalls",
      "level":"1"
   },
   {
      "displayName":"Ad Networks",
      "hashName":"#ad-networks",
      "level":"1"
   }
]` )
}
export const AUTO_REDIRECTS_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ad-review/auto-redirects' ],
    rightMenuNavs: JSON.parse( `[
   {
     "displayName":"Auto-Redirects Report",
     "hashName":"#auto-redirects-report",
     "level":"1"
   },
   {
     "displayName":"Supported Networks",
     "hashName":"#supported-networks",
     "level":"2"
   },
   {
     "displayName":"Metrics",
     "hashName":"#metrics",
     "level":"2"
   },
   {
     "displayName":"Dimensions",
     "hashName":"#dimensions",
     "level":"2"
   },
   {
     "displayName":"End User ID",
     "hashName":"#end-user-id",
     "level":"2"
   }
]` )
}
export const ADVANCED_FEATURES_AD_REVIEW_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/features/ad-review/old' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Key Features",
      "hashName":"#key-features",
      "level":"1"
   },
   {
      "displayName":"Creatives",
      "hashName":"#creatives",
      "level":"2"
   },
   {
      "displayName":"Campaigns",
      "hashName":"#campaigns",
      "level":"2"
   },
   {
      "displayName":"Watchlist",
      "hashName":"#watchlist",
      "level":"2"
   },
   {
      "displayName":"Risky Content",
      "hashName":"#risky-content",
      "level":"2"
   },
   {
      "displayName":"Ad Reporting",
      "hashName":"#ad-reporting",
      "level":"2"
   }
]` )
}

export const AD_REVIEW_USER_JOURNEY_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ad-review/user-journey' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Prerequisites",
      "hashName":"#prerequisistes",
      "level":"1"
   },
   {
      "displayName":"User Journey Reports",
      "hashName":"#user-journey-reports",
      "level":"1"
   },
   {
      "displayName":"Create New Report",
      "hashName":"#create-new-report",
      "level":"1"
   },
   {
      "displayName":"User Journey Timeline",
      "hashName":"#user-journey-timeline",
      "level":"1"
   }
]` )
}

export const AD_REVIEW_RULES_MGMT_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/ad-review/rules-management' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"The /v1/rules/competitors Endpoint",
      "hashName":"#the-/v1/rules/competitors-endpoint",
      "level":"1"
   },
   {
      "displayName":"The /v1/rules/risky Endpoint",
      "hashName":"#the-/v1/rules/risky-endpoint",
      "level":"1"
   },
   {
      "displayName":"Limiting GET Requests to Avoid Timeouts",
      "hashName":"#limiting-get-requests-to-avoid-timeouts",
      "level":"1"
   },
   {
      "displayName":"Valid Rule Values (Android)",
      "hashName":"#valid-rule-values-(android)",
      "level":"1"
   },
   {
      "displayName":"Valid Rule Values (iOS)",
      "hashName":"#valid-rule-values-(ios)",
      "level":"1"
   }
]` )
}

export const GET_STARTED_WITH_MAX_OVERVIEW_TABLE_CONTENTS: TableContents = {
    pathName: [ '/documentation/mediation/max/get-started-with-max' ],
    rightMenuNavs: JSON.parse( `[
   {
      "displayName":"Step 1. Create an Account",
      "hashName":"#step-1.-create-an-account",
      "level":"1"
   },
   {
      "displayName":"Step 2: Create an Ad Unit",
      "hashName":"#step-2:-create-an-ad-unit",
      "level":"1"
   },
   {
      "displayName":"Step 3: Integrate the AppLovin SDK and Networks",
      "hashName":"#step-3:-integrate-the-applovin-sdk-and-networks",
      "level":"1"
   },
   {
      "displayName":"Step 4: Test Your Integration",
      "hashName":"#step-4:-test-your-integration",
      "level":"1"
   },
   {
      "displayName":"Step 5: Connect Your Networks",
      "hashName":"#step-5:-connect-your-networks",
      "level":"1"
   },
   {
      "displayName":"Step 6: Set Up Your Waterfall",
      "hashName":"#step-6:-set-up-your-waterfall",
      "level":"1"
   },
   {
      "displayName":"Step 7: Analyze Your Performance",
      "hashName":"#step-7:-analyze-your-performance",
      "level":"1"
   }
]` )
}

export const CAMPAIGN_MANAGEMENT_CONTENTS: TableContents = {
    pathName: [ "/documentation/mediation/auctions/campaign-management-api" ],
    rightMenuNavs: [
        {
            displayName: 'Third-Party App Authorization Flow',
            hashName: '#third-party-app-authorization-flow',
            level: 1,
        },
        {
            displayName: 'Api Request Authentication',
            hashName: '#api-request-authentication',
            level: 1,
        },
        {
            displayName: '/campaign/campaign_id',
            hashName: '#/campaign/campaign_id',
            level: 1,
        },
        {
            displayName: '/campaigns',
            hashName: '#/campaigns',
            level: 1,
        },
        {
            displayName: '/creative_set/creative_set_id',
            hashName: '#/creative_set/creative_set_id',
            level: 1,
        },
        {
            displayName: '/creative_sets/campaign_id',
            hashName: '#/creative_sets/campaign_id',
            level: 1,
        },
        {
            displayName: '/creative_set_assets/creative_set_id',
            hashName: '#/creative_set_assets/creative_set_id',
            level: 1,
        },
        {
            displayName: '/ad/ad_id',
            hashName: '#/ad/ad_id',
            level: 1,
        },
        {
            displayName: '/ads/creative_set_id',
            hashName: '#/ads/creative_set_id',
            level: 1,
        },
        {
            displayName: '/campaign_targets/campaign_id',
            hashName: '#/campaign_targets/campaign_id',
            level: 1,
        },
        {
            displayName: '/source_bids/campaign_id',
            hashName: '#/source_bids/campaign_id',
            level: 1,
        },
        {
            displayName: '/sources/campaign_id',
            hashName: '#/sources/campaign_id',
            level: 1,
        },
        {
            displayName: 'Appendix',
            hashName: '#appendix',
            level: 1,
        },
        {
            displayName: 'Table of Tracking Methods',
            hashName: '#table-of-tracking-methods',
            level: 2,
        },
        {
            displayName: 'Language Codes',
            hashName: '#language-codes',
            level: 2,
        },
        {
            displayName: 'Asset Types',
            hashName: '#asset-types',
            level: 2,
        },
        {
            displayName: 'Templates',
            hashName: '#templates',
            level: 2,
        },
    ]
}
